/* eslint-disable */
import React, { PropTypes } from 'react';
import _ from 'lodash';
import $ from 'jquery';
import RequiredMark from '../../../commonComponents/RequiredMark';
import { browserHistory } from 'react-router';
import DayPicker from '../../../commonComponents/DayPicker';
import DatePicker from 'react-datepicker';
import moment from 'moment';
// import { Creatable } from 'react-select';
import Select from 'react-virtualized-select';
import { FileDropAreaCt } from '../../../commonComponents/FileDropAreaCt';
import { onFileDrop2, onFileDelete2 } from '../../../commonComponents/onFileModify';
import Tooltip from '../../../commonComponents/Tooltip';
import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';
import RepairPdfContentPs from '../online_repair/RepairPdfContentPs';
import parentStateHandler from '../../../commonJS/parentStateHandler';
import { numberHandler } from '../../../commonJS/addCommasToNumber';
import removeCommasToNumber from '../../../commonJS/removeCommasToNumber';
import exportPDF from '../../../commonJS/exportPDF';
import { textInputOnChange } from '../../../commonJS/onFormChanges';
import PartsSearchAreaCt from '../../../commonComponents/PartsSearchAreaCt';

// import {
// 	TextField, SelectField,
// 	DatePickerInstance, TextAreaField, ReadOnlyField
// } from './OnlineRepairPs';

import {
	Modal, Button, Col, Row, Well,
	FormGroup, ControlLabel, FormControl, HelpBlock, Tabs, Tab
} from 'react-bootstrap';


const Hr = props => <hr style={{ borderTop: '1px solid #ddd', ...props.style }} />;

const part_obj = {
	id: '',
	partId: '',
	partName: '',
	partSpec: '',
	partSpecEname: '',
	details: '',
	quantity: 0,
	bUnitId: '1',
	warrantyPeriod: '0',
	cost: 0,
	price: 0,
	unitPrice: 0,
	extraCost: 0,
	averageUnitPrice: 0,
	subtotal: 0,
	remark: '',
	displayId: '0',
	is_double: false
}

// const TabBtn = (props) => {
// 	const { sm, title, ...otherProps } = props;
// 	return (
// 		<Col sm={props.sm}>
// 			<Button {...otherProps}
// 				style={{ width: '100%' }}>
// 				{props.title}
// 			</Button>
// 		</Col>
// 	);
// }

const DropDownMenu = props => (
	<Col sm={props.sm}>
		<FormGroup validationState={props.validationState} style={{ position: 'relative' }}>
			<ControlLabel>{props.required ? <span style={{ color: 'red' }}>* </span> : ''}{props.label}
				{
					!props.disabled &&
						props.stateName === 'company' ?
						<img role='img' src='/imgs/ic_search_nor.svg' alt='' className='text-center'
							style={{ position: 'absolute', top: -5, right: 5, width: 25, height: 25, cursor: 'pointer' }} onClick={() => { props.showSearchCompanyContactModal() }} />
						: null
				}
			</ControlLabel>
			<div className={'validation-state-' + props.validationState}>
				<Select
					inputProps={{ id: props.id }}
					multi={props.multi}
					openOnFocus={true}
					disabled={props.stateName === 'company' ? true : props.disabled}
					value={props.value}
					valueKey={props.valueKey}
					labelKey={props.labelKey}
					matchProp='label'
					clearable={props.clearable || false}
					placeholder={
						props.stateName === 'company'
							? ''
							: !props.disabled
								? 'Search here'
								: ''
					}
					noResultsText='No results found'
					onChange={selection => { props.onChange(selection, props.stateName); }}
					options={props.options}
					filterOptions={props.filterOptions} />
			</div>
		</FormGroup>
	</Col>
);

const SearchSNResult = props => {
	const { languageData, languageCode } = window.myConsts;

	let
		cancelBtn = (
			<Button onClick={props.closeModal} className='funBtn' style={{ zIndex: 'unset' }}>
				{languageData['452'][languageCode]}
			</Button>
		),
		modeBtns = (
			<Button onClick={props.onSaveSN} className='funBtn'
				disabled={!props.selectSNValue} style={{ zIndex: 'unset' }}>
				{languageData['177'][languageCode]}
				{
					props.selectSNValue
						? ''
						: <Tooltip tipText={'尚有必填欄位未填寫'} />
				}
			</Button>
		);

	return (
		<Modal id='modal-product-spec' show={true} onHide={props.closeModal} bsSize='large'
			keyboard={false} backdrop='static'>
			<Modal.Header>
				<Modal.Title>
					<span className='textLineHeight' style={{ float: 'left' }}>{languageData['444'][languageCode]}</span>
					{cancelBtn}
					{modeBtns}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<FormGroup controlId='selectSN'>
					<ControlLabel><RequiredMark />{`${languageData['444'][languageCode]} (儀器序號 / 客戶全稱 / 聯絡人 / 儀器型號)`}</ControlLabel>
					<Select
						inputProps={{ id: 'selectSNForModal' }}
						openOnFocus={true}
						clearable={false}
						disabled={false}
						valueKey='tag'
						labelKey='name'
						matchProp='label'
						value={props.selectSNValue}
						options={props.serialNumberList}
						onChange={option => props.onSNModalChange(option)}
						placeholder={languageData['528'][languageCode]}
						filterOptions={props.filterOptions}
					/>
				</FormGroup>
			</Modal.Body>
			<Modal.Footer>
				{cancelBtn}
			</Modal.Footer>
		</Modal>
	)
};

const SearchCompanyContactResult = props => {
	const { languageData, languageCode } = window.myConsts;

	let
		{
			activeTabKeySearch,
			searchDataCompany, searchDataContact,
			searchDataValue, searchDataList
		} = props.state,
		disabled = !activeTabKeySearch || !searchDataValue,
		cancelBtn = (
			<Button onClick={props.closeModal} className='funBtn' style={{ zIndex: 'unset' }}>
				{languageData['452'][languageCode]}
			</Button>
		),
		modeBtns = (
			<Button onClick={() => { props.onSave(999) }} className='funBtn'
				disabled={disabled} style={{ zIndex: 'unset' }}>
				{languageData['177'][languageCode]}
				{
					disabled ?
						<Tooltip
							placement='left'
							tipText={'請選擇其中一項搜尋功能'}
						/>
						: null
				}
			</Button>
		);

	return (
		<Modal id='modal-product-spec' show={true} onHide={props.closeModal} bsSize='large'
			keyboard={false} backdrop='static'>
			<Modal.Header>
				<Modal.Title>
					<span className='textLineHeight' style={{ float: 'left' }}>{'客戶全稱/聯絡人員查詢'}</span>
					{cancelBtn}
					{modeBtns}
				</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Tabs activeKey={activeTabKeySearch} id='div-repair-tabs-containers'
					onSelect={() => { props.onTabClickSearch(activeTabKeySearch) }} >
					<Tab eventKey={1} title={'客戶全稱'}>
						<Row>
							<Col sm={11}>
								<input
									style={{ margin: '10px 0 20px' }}
									className='form-control'
									value={searchDataCompany}
									onChange={(event) => { props.setSearchData('searchDataCompany', event.target.value) }} />
							</Col>
							<Col sm={1} style={{ paddingLeft: 0 }}>
								<Button
									style={{
										margin: '10px 0px 20px',
										width: '100%'
									}}
									disabled={!searchDataCompany}
									onClick={(e) => { props.onSearch(activeTabKeySearch, searchDataCompany) }}>
									{languageData['78'][languageCode]}
									{
										!searchDataCompany ?
											<Tooltip
												placement='left'
												tipText={'請輸入客戶全稱關鍵字'}
											/>
											: null
									}
								</Button>
							</Col>
						</Row>
					</Tab>
					<Tab eventKey={2} title={'聯絡人'}>
						<Row>
							<Col sm={11}>
								<input
									style={{ margin: '10px 0 20px' }}
									className='form-control'
									value={searchDataContact}
									onChange={(event) => { props.setSearchData('searchDataContact', event.target.value) }} />
							</Col>
							<Col sm={1} style={{ paddingLeft: 0 }}>
								<Button
									style={{
										margin: '10px 0px 20px',
										width: '100%'
									}}
									disabled={!searchDataContact}
									onClick={(e) => { props.onSearch(activeTabKeySearch, searchDataContact) }}>
									{languageData['78'][languageCode]}
									{
										!searchDataContact ?
											<Tooltip
												placement='left'
												tipText={'請輸入聯絡人關鍵字'}
											/>
											: null
									}
								</Button>
							</Col>
						</Row>
					</Tab>
				</Tabs>
				{
					searchDataList.length > 0 ?
						<div>
							<Hr style={{ margin: 0 }} />
							<Select
								inputProps={{ id: 'companyContactList' }}
								openOnFocus={true}
								clearable={true}
								disabled={false}
								valueKey='id'
								labelKey='name'
								matchProp='label'
								value={searchDataValue ? searchDataValue.id : ''}
								options={searchDataList}
								onChange={(option) => props.onChangeSelectValue(3, option)}
								placeholder={languageData['528'][languageCode]}
								filterOptions={props.filterOptions}
								style={{ margin: '15px 0' }}
							/>
						</div>
						: null
				}
			</Modal.Body>
			<Modal.Footer>
				{cancelBtn}
			</Modal.Footer>
		</Modal>
	)
};

export default class formQuotationModalCt extends React.Component {
	constructor(props) {
		super(props);
		this.handlers = {
			textInputOnChange: e => {
				switch (e.currentTarget.id) {
					case 'machine_name':
					case 'machine_model':
						// 金額明細的備註 規則
						this.handlers.onChangePaymentRemark();
						break;

					default:
				}

				textInputOnChange(e, this);
			},
			onChange: (selection, id, cb) => {
				const value = selection.value;

				let arr = [], arrName = [], len;
				switch (id) {
					case 'quotation_paymentId':
						this.setState({ [id]: value }, () => {
							// 金額明細的備註 規則
							this.handlers.onChangePaymentRemark();
						});
						break;
					case 'quotation_brandId':
						len = selection.length;

						for (let i = 0; i < len; i++) {
							arr.push(selection[i].value);
							arrName.push(selection[i].label);
						}

						this.setState({ [id]: arr, quotation_brandName: arrName.join() }, () => {
							// 金額明細的備註 規則
							this.handlers.onChangePaymentRemark();
						});
						break;

					default:
						this.setState({ [id]: value });
						break;
				}
			},
			onSearchSNResultClick: (isSave) => {
				if (isSave) {
					const { company_data } = this.props,
						{ selectSN } = this.state,
						option = _.find(company_data, { id: selectSN.company_id });

					this.onChangeCompany(option);
					// this.loadContactData(selectSN.company_id);
					// if (selectSN.contact_id === '0') {
					// 	this.setState({
					// 		quotation_customerId: selectSN.customer_id,
					// 		company: { id: selectSN.customer_id, name: selectSN.customer_name },
					// 		contact: null,
					// 		quotation_brandId: selectSN.quotation_brandId ? selectSN.quotation_brandId.split(',') : [],
					// 		serial_number: selectSN.serial_number,
					// 		machine_name: selectSN.machine_name,
					// 		machine_model: selectSN.machine_model
					// 	})
					// } else {
					this.setState({
						quotation_customerId: selectSN.customer_id,
						company: { id: selectSN.company_id, name: selectSN.customer_name },
						contact: { id: selectSN.contact_id, name: selectSN.contact_name },
						// contact_data: { contact_id: selectSN.contact_id, contact_name: selectSN.contact_name },
						contact_tel: selectSN.cell_phone,
						// contact_mobile: selectSN.cell_phone,
						contact_email: selectSN.email,
						quotation_brandId: selectSN.quotation_brandId,
						serial_number: selectSN.serial_number,
						machine_name: selectSN.machine_name,
						machine_model: selectSN.machine_model
					}, () => {
						// 金額明細的備註 規則
						this.handlers.onChangePaymentRemark();
					})
					// }
				}

				this.setState({ selectSNValue: '', showSearchSNResult: false });
			},
			onSNModalChange: (option) => {
				const
					optTag = option === null || option.length === 0
						? ''
						: option.tag,
					optSN = option === null || option.length === 0
						? ''
						: option;

				this.setState({ selectSNValue: optTag, selectSN: optSN });
			},
			onSNLoadCompanyData: () => {
				const { company_data, optsBrand } = this.props,
					SN = $.trim(this.state.serial_number);

				if (SN) {
					this.setState({ is_loaded: false });

					$.ajax({
						type: 'get',
						url: `/api/M_Instrument_Data_Get.php?serial_number=${SN}`,
						success: res => {
							this.setState({ is_loaded: true });

							if (
								res.status === '0' &&
								res.result.length > 0
							) {
								const data = res.result;

								if (data.length === 1) {
									// 結果只有1筆，直接把結果放進欄位
									const option = _.find(company_data, { id: data[0].company_id }),
										findBrand = _.filter(optsBrand, { label: data[0].brand_name });
									this.onChangeCompany(option);

									// if (data[0].contact_id === '0') {
									// 	this.setState({
									// 		company: { id: data[0].customer_id, name: data[0].customer_name },
									// 		serialNumberList: data,
									// 		quotation_brandId: findBrand.length > 0 && findBrand[0].value ? findBrand[0].value.split(',') : [],
									// 		serial_number: data[0].machine_number,
									// 		machine_name: data[0].machine_name,
									// 		machine_model: data[0].machine_model
									// 	});
									// } else {
									this.setState({
										quotation_customerId: data[0].customer_id,
										company: { id: data[0].company_id, name: data[0].customer_name },
										contact: { id: data[0].contact_id, name: data[0].contact_name },
										// contact_data: { contact_id: data[0].contact_id, contact_name: data[0].contact_name },
										contact_tel: data[0].cell_phone,
										// contact_mobile: data[0].cell_phone,
										contact_email: data[0].email,
										serialNumberList: data,
										quotation_brandId: findBrand.length > 0 && findBrand[0].value ? findBrand[0].value.split(',') : [],
										serial_number: data[0].machine_number,
										machine_name: data[0].machine_name,
										machine_model: data[0].machine_model
									});
									// }
								} else if (data.length > 1) {
									// 結果有N筆，要出現選擇畫面
									let serialNumberList = [];
									for (let idx = 0; idx < data.length; idx++) {
										const findBrand = _.filter(optsBrand, { label: data[idx].brand_name });

										serialNumberList.push({
											customer_id: data[idx].customer_id,
											company_id: data[idx].company_id,
											customer_name: data[idx].customer_name,
											contact_id: data[idx].contact_id,
											contact_name: data[idx].contact_name,
											quotation_brandId: findBrand.length > 0 && findBrand[0].value ? findBrand[0].value.split(',') : [],
											serial_number: data[idx].machine_number,
											machine_name: data[idx].machine_name,
											machine_model: data[idx].machine_model,
											name: `${data[idx].machine_number} / ${data[idx].customer_name} / ${data[idx].contact_name} / ${data[idx].machine_model}`,
											tag: `${data[idx].company_id} / ${data[idx].machine_number} / ${data[idx].customer_id} / ${data[idx].customer_name} / ${data[idx].contact_id} / ${data[idx].contact_name} / ${data[idx].machine_model}`,
											dataSource: data[idx]
										});
									}

									this.setState({
										serialNumberList,
										showSearchSNResult: true
									}, () => {
										$('#selectSNForModal').focus();
									});
								}
							} else { alert('查無資料'); }
						}
					});
				}
			},
			onShowSearchCompanyContactModal: (type) => {
				if (type === 1) {
					this.setState({
						activeTabKeySearch: 1,
						searchDataValue: '',
						searchDataList: [],
						showSearchCompanyContactModal: true
					})
				} else {
					this.setState({
						searchDataCompany: '',
						searchDataContact: '',
						showSearchCompanyContactModal: false
					})
				}
			},
			onSearchCompanyData: (type, data_) => {
				const data = $.trim(data_);

				let searchDataList = [];
				switch (type) {
					case 1:
						$.ajax({
							type: 'GET',
							url: `/api/M_Companys_ByName_Get.php?company_name=${data}`,
							complete: xhr => {
								const data = xhr.responseJSON;

								if (data.status === '0') {
									searchDataList =
										data.result.map((x, y) => {
											return {
												id: `${x.customer_id}/${x.contact_id}`,
												name: `${x.customer_id}　${x.company_name}　${x.contact_name}`,
												address: x.address,
												...x
											}
										});
								} else alert('查無資料');

								this.setState({
									searchDataList,
									searchDataValue: ''
								}, () => {
									$('#companyContactList').focus();
								});
							}
						});
						break;
					case 2:
						$.ajax({
							type: 'GET',
							url: `/api/M_Contacts_ByName_Get.php?contact_name=${data}`,
							complete: xhr => {
								const data = xhr.responseJSON;

								if (data.status === '0') {
									searchDataList =
										data.result.map((x, y) => {
											return {
												id: `${x.customer_id}/${x.contact_id}`,
												name: `${x.customer_id} ${x.company_name} ${x.contact_name}`,
												address: x.address,
												...x
											}
										});
								} else alert('查無資料');

								this.setState({
									searchDataList,
									searchDataValue: ''
								}, () => {
									$('#companyContactList').focus();
								});
							}
						});
						break;
					case 3:
						this.setState({ searchDataValue: data_ ? data_ : '' })
						break;
					case 999:
						const { searchDataValue } = this.state,
							item_ = [searchDataValue],
							item =
								item_.map((x, y) => {
									return {
										id: x.company_id,
										name: x.company_name,
										address: x.address,
										cell_phone: x.cell_phone,
										company_id: x.company_id,
										company_name: x.company_name,
										company_sname: x.company_sname,
										contact_address: x.contact_address,
										contact_id: x.contact_id,
										contact_name: x.contact_name,
										contact_work_phone: x.contact_work_phone,
										customer_id: x.customer_id,
										department_name: x.department_name,
										email: x.email,
										president: x.president,
										tax_number: x.tax_number,
										telephone: x.telephone
									}
								});

						if (item.length > 0) {
							const thisItem = item[0];

							this.setState({
								quotation_customerId: thisItem.customer_id,
								contact_tel: thisItem.contact_work_phone,
								// contact_mobile: thisItem.contact_mobile,
								contact_email: thisItem.email,
							}, () => {
								this.onChangeCompany(thisItem);
							})
						}
						this.handlers.onShowSearchCompanyContactModal(0);
						break;

					default:
				}
			},
			onChangePaymentRemark: () => {
				const
					{
						optsBrand,
						optsTypeStatus,
						// optsMchineType_sales,
						// optsMchineType_svc,
						optsPaymentRemark
					} = this.props,
					{
						machine_name,
						machine_model,
						serial_number,
						quotation_brandId,
						quotation_bTypeId,
						// quotation_bMachineType,
						quotation_paymentId
					} = this.state;

				// if (quotation_bTypeId && quotation_brandId.length) {
				let getTypeName = '', getBrandName = '';
				const findTypeData = _.filter(optsTypeStatus, { value: quotation_bTypeId });
				if (findTypeData.length > 0) getTypeName = findTypeData[0].label;

				_.forEach(quotation_brandId, (val, key) => {
					const findBrandData = _.filter(optsBrand, { value: val });

					if (findBrandData.length > 0) getBrandName += `${findBrandData[0].label}、`;
				});

				// if (quotation_bTypeId === '1' && quotation_bMachineType) {
				// 	const findMachineTypeData = _.filter(optsMchineType_sales, { value: quotation_bMachineType });

				// 	if (findMachineTypeData.length > 0) getMachineTypeName = findMachineTypeData[0].label;
				// } else if (quotation_bTypeId === '2' && quotation_bMachineType) {
				// 	const findMachineTypeData = _.filter(optsMchineType_svc, { value: quotation_bMachineType });

				// 	if (findMachineTypeData.length > 0) getMachineTypeName = findMachineTypeData[0].label;
				// }
				const findData = _.filter(optsPaymentRemark, { doctype_id: quotation_bTypeId, payment_id: quotation_paymentId || '0' });

				let quotation_paymentRemark = '';
				// if (quotation_bTypeId === '1' && quotation_bMachineType === '1') {
				// 	findData = _.filter(optsPaymentRemark, { doctype_id: '1', payment_id: quotation_paymentId });
				// } else if (quotation_bTypeId === '1' && quotation_bMachineType === '2') {
				// 	findData = _.filter(optsPaymentRemark, { doctype_id: '1', payment_id: '0' });
				// } else if (quotation_bTypeId === '2' && quotation_bMachineType === '1') {
				// 	findData = _.filter(optsPaymentRemark, { doctype_id: '2', payment_id: '1' });
				// } else if (quotation_bTypeId === '2' && quotation_bMachineType === '2') {
				// 	findData = _.filter(optsPaymentRemark, { doctype_id: '2', payment_id: '2' });
				// }
				if (findData.length > 0) {
					quotation_paymentRemark =
						findData[0].content
							.replace('[mname]', machine_name || '')
							.replace('[mmode]', machine_model || '')
							.replace('[mnum]', serial_number || '')
							.replace('[mbrandname]', getBrandName.substr(0, getBrandName.length - 1) || '');
				}

				this.setState({ quotation_paymentRemark })
				// }
			},
			onCalProductListSubtotal: () => {
				const { parts } = this.state,
					filterParts = _.filter(parts, function (o) { return o.itemFlag !== 'delete' })

				let totalprice = 0;
				_.forEach(filterParts, (val, key) => {
					totalprice += val.subtotal * 1 || 0;
				});

				this.setState({ quotation_totalAmount: totalprice })
			}
		}

		// exporting pdf ===
		this.onExportPdfWithPhotoClick = (mode, batchStock, givenName, resolve) => {
			this.exportPhoto = true;
			this.setState({ showPdfContent: true }, () => { this.exportPdf(mode, batchStock, givenName, resolve) });
		}

		this.onExportPdfWithoutPhotoClick = (mode, batchStock, givenName, resolve) => {
			this.exportPhoto = false;
			this.setState({ showPdfContent: true }, () => { this.exportPdf(mode, batchStock, givenName, resolve) });
		}

		this.pdfContentCreater = () => {
			const state = this.state,
				pages = [],
				parts = _.filter(state.parts, function (o) { return o.itemFlag !== 'delete' }),
				partLen = parts.length,
				loginCompanyInfo = {
					companyTitle: sessionStorage.companyTitle,
					companyLogo: sessionStorage.companyLogo,
					companyTel: sessionStorage.companyTel,
					companyFax: sessionStorage.companyFax,
					companyAddress: sessionStorage.companyAddress,
					companyEmail: sessionStorage.companyEmail
				},
				data = {
					loginCompanyInfo,
					statusName: _.find(this.props.status_data, { status_id: this.state.status }).status_name,
					// * 1 以正確判斷文字'0'的情況
					// formTypeName: this.state.form_type * 1 ? _.find(this.props.form_type_data, { type_id: this.state.form_type }).type_name : '',
					// areaTypeName: this.state.area * 1 ? _.find(this.props.area_data, { area_type_id: this.state.area }).area_type_name : '',
					contractName: this.state.maintain_contract * 1 ? _.find(this.state.contact_data, { warranty_type_id: this.state.maintain_contract }).warranty_type_name : '',
					factoryName: this.state.factory * 1 ? _.find(this.props.factory_data, { factory_id: this.state.factory, company_id: this.state.company.id }).factory_name : '',
					// judgeName: this.state.responsibility * 1 ? _.find(this.props.responsibility_data, { judge_id: this.state.responsibility }).judge_name : '',
					satisfactionName: this.state.service_result * 1 ? _.find(this.props.service_result_data, { satisfaction_id: this.state.service_result }).satisfaction_name : '',
					// currencyName: this.state.currency * 1 ? _.find(this.props.currency_data, { currency_id: this.state.currency }).currency_name : '',
					...this.state
				};

			// id陣列轉名稱字串函式
			function convertToNameStr(objToExtend, extendKeyName, stateName, dataProps, keyToFind, nameKey) {
				// 有選擇時才處理
				objToExtend[extendKeyName] = (state[stateName] && state[stateName] !== '0') ? (function (self) {
					// id轉array
					const idArr = state[stateName].split(','),
						nameArr = [],
						len = idArr.length

					for (let i = 0; i < len; i++) {
						nameArr.push(_.find(self.props[dataProps], { [keyToFind]: idArr[i] })[nameKey]);
					}
					// 使用'、'分隔將array轉成字串
					return nameArr.join('、');
				}(this)) : '';
			}

			// 綁定this與第一個參數
			convertToNameStr = convertToNameStr.bind(this, data);
			// 名稱字串轉 array 再用指定分隔符號轉字串
			data['assignedMenNames'] = state.assignedMenNames.split(',').join('、');
			// convertToNameStr(
			// 	'serviceTypeNames',
			// 	'service_type', 'service_type_data', 'service_type_id', 'service_type_name'
			// );
			// main page
			pages.push(<RepairPdfContentPs key={pages.length} pdfType='main' data={data} />);

			// part pages
			if (partLen > 5) {
				// 超過5筆才會有清單頁，每頁最多23筆
				const partListPages = Math.ceil(partLen / 23);

				for (let i = 0; i < partListPages; i++) {
					const startInd = i * 23,
						// 超過最後1筆時取最後1筆的索引
						endInd = Math.min(startInd + 22, (partLen - 1)),
						// + 1原因為slice不含尾端
						filteredPartsList = parts.slice(startInd, endInd + 1);

					pages.push(<RepairPdfContentPs key={pages.length} startInd={startInd} pdfType='partList' filteredPartsList={filteredPartsList} data={data} />);
				}

			}

			// photo pages
			if (this.exportPhoto) {
				// qmo不知為何未把repair_downloadedFiles與maintain_downloadedFiles列在state初始
				// 為免預期之外的影響，不去改動它，改成使用前判斷屬性是否存在

				// 過濾圖片檔案
				const issuePhotos = [], repairPhotos = [];

				if (state.repair_downloadedFiles) {
					state.repair_downloadedFiles.forEach((item, ind) => {
						if (item.type.indexOf('image') !== -1) issuePhotos.push(item);
					});
				}

				if (state.maintain_downloadedFiles) {
					state.maintain_downloadedFiles.forEach((item, ind) => {
						if (item.type.indexOf('image') !== -1) repairPhotos.push(item);
					})
				}

				const issuePhotoLen = issuePhotos.length,
					repairPhotoLen = repairPhotos.length,
					// 除以4進位得到半頁數，兩半頁成1頁
					issuePhotoPages = Math.floor(Math.ceil(issuePhotoLen / 4) / 2);

				// 記錄不成整頁的issue photo起始索引與結束索引
				// initial為-1, -2做為是否有剩餘不成整頁判斷
				let issueRemainPhotoStartInd = 0, issueRemainPhotoEndInd = issuePhotoLen - 1;


				// 處理成整頁的issue photos
				for (let i = 0; i < issuePhotoPages; i++) {
					const startInd = i * 8,
						// 超過最後1筆時取最後1筆的索引
						endInd = Math.min(startInd + 7, (issuePhotoLen - 1)),
						// + 1原因為slice不含尾端
						issueFilteredPhotos = issuePhotos.slice(startInd, endInd + 1);

					pages.push(<RepairPdfContentPs key={pages.length} pdfType='photo' issueFilteredPhotos={issueFilteredPhotos} data={data} />);

					// 記錄成整頁的最後一筆索引做為餘下不成整頁的起始索引
					if (i === (issuePhotoPages - 1)) {
						// 有剩餘的情況
						if (issuePhotoLen > (endInd + 1)) {
							issueRemainPhotoStartInd = endInd + 1;
							issueRemainPhotoEndInd = issuePhotoLen - 1;
							// 無剩餘的情況
						} else {
							issueRemainPhotoStartInd = 0;
							issueRemainPhotoEndInd = - 1;
						}
					}
				}

				// 處理不成整頁的issue photos與maintain photos
				// issue photo有剩餘就一定只有半頁
				let issueRemainingPhotos;
				if ((issueRemainPhotoEndInd - issueRemainPhotoStartInd) >= 0) {
					issueRemainingPhotos = issuePhotos.slice(issueRemainPhotoStartInd, issueRemainPhotoEndInd + 1);
				}

				const repairPhotoPageUnits = Math.ceil(repairPhotoLen / 4) + (issueRemainingPhotos ? 1 : 0),
					repairPhotoPages = Math.ceil(repairPhotoPageUnits / 2);

				for (let i = 0; i < repairPhotoPages; i++) {
					// issue photo有剩餘時，repair photo位置需平移
					const startInd = (i * 8) - ((issueRemainingPhotos && i > 0) ? 4 : 0),
						// 超過最後1筆時取最後1筆的索引
						endInd = Math.min(startInd + 7 - ((issueRemainingPhotos && i === 0) ? 4 : 0), (repairPhotoLen - 1)),
						// + 1原因為slice不含尾端
						repairFilteredPhotos = repairPhotoLen ? repairPhotos.slice(startInd, endInd + 1) : [];

					if (issueRemainingPhotos && i === 0) {
						pages.push(<RepairPdfContentPs key={pages.length} pdfType='photo' issueRemainingPhotos={issueRemainingPhotos} repairFilteredPhotos={repairFilteredPhotos} data={data} />);
					} else {
						pages.push(<RepairPdfContentPs key={pages.length} pdfType='photo' repairFilteredPhotos={repairFilteredPhotos} data={data} />);
					}
				}
			}

			return pages;
		}

		this.exportPdf = (mode, batchStock, givenName, resolve) => {
			const jqEleContainers = $('.pdf-content-container'),
				fileName = givenName || `估價單_${this.state.quotation_docId}`;

			exportPDF(jqEleContainers, fileName, () => {
				this.setState({ showPdfContent: false }, resolve);
			}, mode, batchStock);

		};

		// 是否輸出圖片依據
		this.exportPhoto = true;

		// this.onTabClick = activeTabKey => {
		// 	this.setState({ activeTabKey });
		// };

		this.onTabClickSearch = activeTabKeySearch => {
			this.setState({ activeTabKeySearch: activeTabKeySearch === 1 ? 2 : 1 });
		};

		// ===
		this.state = {
			searchDataList: [],
			searchDataValue: '',
			searchDataCompany: '',
			searchDataContact: '',
			showSearchCompanyContactModal: false,
			showPartsSearchArea: false,
			quotation_status: '0',
			quotation_customerId: '',
			// quotation_customerName: '',
			company: null,				//公司
			factory: '0',				//廠區
			factory_data: [],
			contact: null,				//聯絡人
			contact_data: [],
			address: '',
			contact_tel: '',			//聯絡電話
			contact_mobile: '',		//行動電話
			contact_email: '',		//Email
			repair_man_id: this.props.user_id || '',
			repair_man_name: this.props.user_name || '',
			quotation_docId: '',
			quotation_bTypeId: '',
			quotation_bStageId: '',
			quotation_bTakeId: '',
			quotation_bModelId: '',
			quotation_creatorId: this.props.user_id || '',
			quotation_creatorName: this.props.user_name || '',
			quotation_quotationDate: moment(),
			quotation_expiryDate: moment().add(30, 'd'),
			quotation_bDeliveryId: '',
			quotation_bCurrencyId: '',
			quotation_bTaxId: '',
			quotation_bMachineType: '',
			quotation_brandId: [],
			quotation_subcost: 0,
			quotation_totalAmount: 0,
			quotation_dealAmount: 0,
			quotation_paymentId: '',
			quotation_paymentRemark: '',
			quotation_productRemark: '',
			machine_model: '',
			machine_name: '',
			serial_number: '',
			showSearchSNResult: false,
			selectSN: '',
			selectSNValue: '',
			serialNumberList: [],
			parts: [],								//零件資訊
			parts_orig: [],						//原始零件資訊
			btnSaveDisable: true
		}

		this.onChangeContact = this.onChangeContact.bind(this);
		// this.onChangePartNumber = this.onChangePartNumber.bind(this);
		// this.onChangePartName = this.onChangePartName.bind(this);
		this.uploadFiles = this.uploadFiles.bind(this);
		this.deleteFiles = this.deleteFiles.bind(this);

		this.doSaveAJAX = formData => {
			const { closeModal } = this.props;

			let mode;
			// 編輯情境
			if ((this.props.params && this.props.params.id) || this.props.selectedItemId) {
				mode = 'edit';
				// 新增情境
			} else {
				mode = 'add';
			}

			$.ajax({
				type: 'post',
				url: `/api/M_Quotation_Data_${mode === 'add' ? 'Post' : 'Update'}.php`,
				data: formData,
				processData: false,
				contentType: false,
				success: res => {
					if (res.status === '0') {
						this.setState({ is_error: false, enableEdit: false })

						const docId = res.result.doc_id;
						// 處理產品明細
						const { parts_orig, parts } = this.state, len = parts.length;
						if (len > 0) {
							// 由於API關係，需要先判斷過濾delete後是否比原先的資料多
							const filterDelList = _.filter(parts, function (o) { return o.itemFlag !== 'delete' });

							if (mode === 'add') {
								// 新增模式
								if (filterDelList.length > 0) {
									for (let postIdx = 0; postIdx < filterDelList.length; postIdx++) {
										let formData = new FormData();
										formData.append('doc_id', docId);
										formData.append('item', (postIdx + 1));
										formData.append('product_id', parts[postIdx].part_id);
										formData.append('display_id', parts[postIdx].displayId || '0');
										formData.append('product_id', parts[postIdx].partId);
										formData.append('spec', parts[postIdx].partSpec);
										formData.append('spec_ename', parts[postIdx].partSpecEname);
										formData.append('spec_details', parts[postIdx].details);
										formData.append('quantity', parts[postIdx].quantity);
										formData.append('b_unit_id', parts[postIdx].bUnitId);
										formData.append('warranty_period', parts[postIdx].warrantyPeriod);
										formData.append('cost', parts[postIdx].cost);
										formData.append('price', parts[postIdx].price);
										formData.append('unit_price', parts[postIdx].unitPrice);
										formData.append('extra_cost', parts[postIdx].extraCost);
										formData.append('average_unit_price', parts[postIdx].averageUnitPrice);
										formData.append('subtotal', parts[postIdx].subtotal);

										$.ajax({
											type: 'post',
											url: '/api/M_Quotation_Data_Detail_Post.php',
											data: formData,
											processData: false,
											contentType: false,
											async: false,
											success: res => {
												if ((postIdx + 1) === filterDelList.length) {
													this.props.reload(mode);

													closeModal();
												}
											}
										});
									}
								} else {
									this.props.reload(mode);

									closeModal();
								}
							} else {
								// 處理修改/刪除
								if (parts_orig.length !== parts.length) {
									// 項目數量與原始資料數量不一致
									if (parts_orig.length > parts.length) {
										// 比原始資料少
										const overCount = parts_orig.length - parts.length;
										// 由於新資料項目比原始資料少
										// 所以依據API運作模式，把新項目都用更新處理
										// 舊資料多出來的項目使用delete處理
										for (let idxOver = 0; idxOver < filterDelList.length; idxOver++) {
											let formData = new FormData();

											formData.append('doc_id', docId);
											formData.append('item', (idxOver + 1));
											formData.append('display_id', parts[idxOver].displayId || '0');
											formData.append('product_id', parts[idxOver].partId);
											formData.append('spec', parts[idxOver].partSpec);
											formData.append('spec_ename', parts[idxOver].partSpecEname);
											formData.append('spec_details', parts[idxOver].details);
											formData.append('quantity', parts[idxOver].quantity);
											formData.append('b_unit_id', parts[idxOver].bUnitId);
											formData.append('warranty_period', parts[idxOver].warrantyPeriod);
											formData.append('cost', parts[idxOver].cost);
											formData.append('price', parts[idxOver].price);
											formData.append('unit_price', parts[idxOver].unitPrice);
											formData.append('extra_cost', parts[idxOver].extraCost);
											formData.append('average_unit_price', parts[idxOver].averageUnitPrice);
											formData.append('subtotal', parts[idxOver].subtotal);

											$.ajax({
												type: 'post',
												url: '/api/M_Quotation_Data_Detail_Update.php',
												data: formData,
												processData: false,
												contentType: false,
												async: false,
												success: res => {
													if ((idxOver + 1) === filterDelList.length) {
														this.props.reload(mode);

														closeModal();
													}
												}
											});
										}

										for (let idxDel = overCount - 1; idxDel >= 0; idxDel--) {
											let formData = new FormData();
											formData.append('doc_id', docId);
											formData.append('item', parts_orig[(parts_orig.length - 1) - idxDel].id);

											$.ajax({
												type: 'post',
												url: '/api/M_Quotation_Data_Detail_Delete.php',
												data: formData,
												processData: false,
												contentType: false,
												async: false,
												success: res => { }
											});
										}
									} else if (parts_orig.length < parts.length) {
										// 比原始資料多
										const overCount = parts.length - parts_orig.length;
										// 由於新資料項目比原始資料少
										// 所以依據API運作模式，把新項目都用更新處理
										// 舊資料多出來的項目使用delete處理
										for (let idxOver = 0; idxOver < filterDelList.length; idxOver++) {
											let formData = new FormData();

											formData.append('doc_id', docId);
											formData.append('item', (idxOver + 1));
											formData.append('display_id', parts[idxOver].displayId || '0');
											formData.append('product_id', parts[idxOver].partId);
											formData.append('spec', parts[idxOver].partSpec);
											formData.append('spec_ename', parts[idxOver].partSpecEname);
											formData.append('spec_details', parts[idxOver].details);
											formData.append('quantity', parts[idxOver].quantity);
											formData.append('b_unit_id', parts[idxOver].bUnitId);
											formData.append('warranty_period', parts[idxOver].warrantyPeriod);
											formData.append('cost', parts[idxOver].cost);
											formData.append('price', parts[idxOver].price);
											formData.append('unit_price', parts[idxOver].unitPrice);
											formData.append('extra_cost', parts[idxOver].extraCost);
											formData.append('average_unit_price', parts[idxOver].averageUnitPrice);
											formData.append('subtotal', parts[idxOver].subtotal);

											$.ajax({
												type: 'post',
												url: '/api/M_Quotation_Data_Detail_Update.php',
												data: formData,
												processData: false,
												contentType: false,
												async: false,
												success: res => {
													if (res.status !== '0') {
														let formDataAdd = new FormData();

														formDataAdd.append('doc_id', docId);
														formDataAdd.append('item', (idxOver + 1));
														formDataAdd.append('display_id', parts[idxOver].displayId || '0');
														formDataAdd.append('product_id', parts[idxOver].partId);
														formDataAdd.append('spec', parts[idxOver].partSpec);
														formDataAdd.append('spec_ename', parts[idxOver].partSpecEname);
														formDataAdd.append('spec_details', parts[idxOver].details);
														formDataAdd.append('quantity', parts[idxOver].quantity);
														formDataAdd.append('b_unit_id', parts[idxOver].bUnitId);
														formDataAdd.append('warranty_period', parts[idxOver].warrantyPeriod);
														formDataAdd.append('cost', parts[idxOver].cost);
														formDataAdd.append('price', parts[idxOver].price);
														formDataAdd.append('unit_price', parts[idxOver].unitPrice);
														formDataAdd.append('extra_cost', parts[idxOver].extraCost);
														formDataAdd.append('average_unit_price', parts[idxOver].averageUnitPrice);
														formDataAdd.append('subtotal', parts[idxOver].subtotal);

														$.ajax({
															type: 'post',
															url: '/api/M_Quotation_Data_Detail_Post.php',
															data: formDataAdd,
															processData: false,
															contentType: false,
															async: false,
															success: res => {
																if ((idxOver + 1) === filterDelList.length) {
																	this.props.reload(mode);

																	closeModal();
																}
															}
														});
													} else {
														if ((idxOver + 1) === filterDelList.length) {
															this.props.reload(mode);

															closeModal();
														}
													}
												}
											});
										}
									}
								} else {
									// 剛剛好
									for (let idx0 = 0; idx0 < len; idx0++) {
										let formData = new FormData(), isOld = true;

										if (parts[idx0].itemFlag !== 'delete') {
											formData.append('doc_id', docId);
											formData.append('item', (idx0 + 1));
											formData.append('display_id', parts[idx0].displayId || '0');
											formData.append('product_id', parts[idx0].partId);
											formData.append('spec', parts[idx0].partSpec);
											formData.append('spec_ename', parts[idx0].partSpecEname);
											formData.append('spec_details', parts[idx0].details);
											formData.append('quantity', parts[idx0].quantity);
											formData.append('b_unit_id', parts[idx0].bUnitId);
											formData.append('warranty_period', parts[idx0].warrantyPeriod);
											formData.append('cost', parts[idx0].cost);
											formData.append('price', parts[idx0].price);
											formData.append('unit_price', parts[idx0].unitPrice);
											formData.append('extra_cost', parts[idx0].extraCost);
											formData.append('average_unit_price', parts[idx0].averageUnitPrice);
											formData.append('subtotal', parts[idx0].subtotal);

											$.ajax({
												type: 'post',
												url: `/api/M_Quotation_Data_Detail_${isOld ? 'Update' : 'Post'}.php`,
												data: formData,
												processData: false,
												contentType: false,
												async: false,
												success: res => {
													if ((idx0 + 1) === parts.length) {
														this.props.reload(mode);

														closeModal();
													}
												}
											});
										} else {
											if (parts[idx0].id !== '') {
												let formData = new FormData();
												formData.append('doc_id', docId);
												formData.append('item', parts[idx0].id);

												$.ajax({
													type: 'post',
													url: '/api/M_Quotation_Data_Detail_Delete.php',
													data: formData,
													processData: false,
													contentType: false,
													async: false,
													success: res => {
														if ((idx0 + 1) === parts.length) {
															this.props.reload(mode);

															closeModal();
														}
													}
												});
											}
										}
									}
								}
							}
						}

						// this.uploadFiles('RepairIssue', res.result.id)
						// this.uploadFiles('RepairSolution', res.result.id)
						// this.setState({ repair_content_files: [], maintain_content_files: [] })

						// if (mode === 'edit') {
						// 	this.deleteFiles('RepairIssue', res.result.id)
						// 	this.deleteFiles('RepairSolution', res.result.id)
						// 	this.setState({ delete_repair_files: [], delete_maintain_files: [] })
						// }
					} else { alert(res.msg) }
				},
				error: error => { }
			});
		};

		this.togglePartsSearchArea = () => {
			this.setState({ showPartsSearchArea: !this.state.showPartsSearchArea });
		};

		this.onAddToParts = (selectedPart) => {
			const newArr = this.state.parts.slice();

			newArr.push({
				partId: selectedPart.product_id,
				partSpec: selectedPart.spec,
				partSpecEname: selectedPart.product_ename,
				details: selectedPart.spec_details,
				quantity: 0,
				bUnitId: '1',
				warrantyPeriod: '0',
				cost: removeCommasToNumber(selectedPart.purchase_price * 1 || 0),
				cost_orig: removeCommasToNumber(selectedPart.purchase_price * 1 || 0),
				price: removeCommasToNumber(selectedPart.list_price * 1 || 0),
				price_orig: removeCommasToNumber(selectedPart.list_price * 1 || 0),
				unitPrice: 0,
				extraCost: 0,
				// averageUnitPrice = (報價單價[unitPrice]*數量[quantity]+附加費用[extraCost])/數量[quantity]
				averageUnitPrice: removeCommasToNumber(0),
				// subtotal = ((報價單價[unitPrice]*數量[quantity]+附加費用[extraCost])/數量[quantity])*數量[quantity]
				subtotal: removeCommasToNumber(0),
				remark: '',
				display_id: '0',
				is_double: false
			});

			this.setState({ parts: newArr });
		};

		this.parentStateHandler = ({ states, newValues }) => {
			parentStateHandler({ states, newValues, parentThis: this });
		};

		// file crud相關 ===========
		// for file upload，不需渲染的資料不使用state，避免多餘的render check
		// this.uploadedFiles = [];

		// for downloaded files that uploaded before
		this.onFileDrop = (downloadedFiles, previews) => {
			onFileDrop2(downloadedFiles, '', this, true, '', previews);
		};

		this.onFileDelete = (type, fileName, previews) => {
			onFileDelete2(type, fileName, this, true, previews);
		};

		// 配合api
		this.fileFilter = (orinFiles) => {
			// 檔案預處理
			let name = '', dotInd = '', type = '';

			const downloadedFiles = orinFiles.map((item, ind) => {
				name = item.file_name;
				dotInd = name.lastIndexOf('.');
				type = name.slice(dotInd + 1);

				let name_split = name.split('/'),
					name_split2 = name_split[(name_split.length - 1)].split('.'),
					file_id = name_split2[0];

				item.file_id = file_id

				switch (type) {
					case 'jpg':
						item.type = 'image/jpeg';
						break;
					case 'png':
						item.type = 'image/png';
						break;
					case 'svg':
						item.type = 'image/svg+xml';
						break;
					case 'pdf':
						item.type = 'application/pdf';
						break;
					case 'mp4':
						item.type = 'video/mp4';
						break;
					default:
				}

				return item;
			});

			return downloadedFiles;
		};
	}

	componentDidMount() {
		const { params, company_data } = this.props;

		let mode;
		// 編輯情境
		if ((this.props.params && this.props.params.id) || this.props.selectedItemId) {
			mode = 'edit';
			// 新增情境
		} else {
			mode = 'add';
		}

		switch (mode) {
			case 'add':
				const { optsTypeStatus, optsStage, optsTake, optsModelStatus, optsCurrency, optsTax } = this.props;

				this.setState({
					is_loaded: true,
					enableEdit: true,
					quotation_bTypeId: optsTypeStatus.length > 0 ? optsTypeStatus[0].value : '1',
					quotation_bStageId: optsStage.length > 0 ? optsStage[0].value : '1',
					quotation_bTakeId: optsTake.length > 0 ? optsTake[0].value : '1',
					quotation_bModelId: optsModelStatus.length > 0 ? optsModelStatus[0].value : '1',
					quotation_bCurrencyId: optsCurrency.length > 0 ? optsCurrency[0].value : '1',
					quotation_bTaxId: optsTax.length > 0 ? optsTax[0].value : '1'
				}, () => { this.handlers.onChangePaymentRemark(); });

				// 客戶資訊tab情況下，預設指定公司
				if (!this.props.params) {
					const option = _.find(company_data, { id: this.props.company_id });
					this.onChangeCompany(option);
				}
				break;

			default:
				if (
					(
						params &&
						(
							params.id === 'pdf-export-withoutphoto' ||
							params.id === 'pdf-export'
						)
					) ||
					// 客戶資訊tab底下的情況
					this.props.selectedItemId.indexOf('pdfBacthExport') !== -1
				) {
					// 在匯出pdf時重整page情境處理
					if (!this.props.arrCheckedId.length) this.props.closeModal()

					// 開始批次匯出pdf
					// 依勾選id清單逐筆抓資料、建立html、截圖
					// 同時存在的html只有1份，全部截圖完成後，產生pdf
					// 流程用點擊下一筆的方式逐一處理
					const batchStock = [],
						arrCheckedId = this.props.arrCheckedId.slice(),
						len = arrCheckedId.length;

					// 定義遞迴函式
					const batchExportPDF = (batchStock, i, withPhoto) => {
						this.loadData(arrCheckedId[i], () => {
							// 三個參數依序為mode, batchStock, givenName
							// 前兩者一體，有就都要給
							// 此筆是否已是最後一筆，+1之後等於len代表此為最後一筆
							const isLast = ++i === len;

							let pm;

							if (withPhoto) {
								pm = new Promise((reso, rej) => { this.onExportPdfWithPhotoClick(isLast ? 'doBatchExport' : 'batching', batchStock, isLast ? 'pdfbundle' : null, reso) });
							} else {
								pm = new Promise((reso, rej) => { this.onExportPdfWithoutPhotoClick(isLast ? 'doBatchExport' : 'batching', batchStock, isLast ? 'pdfbundle' : null, reso) });
							}

							// 確保順序
							pm.then((value) => {
								// +1之後如果小於len則繼續，否則結束
								if (isLast) {
									// 結束匯出中…狀態，並清除勾選
									const arrIsCheck = this.props.arrIsCheck.map(() => false);
									this.props.parentStateHandler({ states: ['onExportPDF', 'arrCheckedId', 'arrIsCheck'], newValues: [false, [], arrIsCheck] });

									this.props.closeModal();
									return;
								}
								// 遞迴，++i時i已+1
								batchExportPDF(batchStock, i, withPhoto);
							}).catch((error) => {
								// 以下預防有錯誤時ui卡住
								// 結束匯出中…狀態，並清除勾選
								const arrIsCheck = this.props.arrIsCheck.map(() => false);
								this.props.parentStateHandler({ states: ['onExportPDF', 'arrCheckedId', 'arrIsCheck'], newValues: [false, [], arrIsCheck] });
								this.props.closeModal();
							});

						});
					};

					if (
						(
							params &&
							params.id === 'pdf-export-withoutphoto'
						) ||
						this.props.selectedItemId === 'pdfBacthExport-withoutphoto'
					) {
						batchExportPDF(batchStock, 0, 0);
					} else {
						batchExportPDF(batchStock, 0, 1);
					}
				} else {
					// 正常edit
					this.loadData(this.props.selectedItemId || params.id);
				}

		}
	}

	componentWillReceiveProps(nextProps) {
		// 一般情況先檢查是否存在
		if (nextProps.params && this.props.params) {
			if (nextProps.params.id !== this.props.params.id) {
				this.loadData(nextProps.params.id)
			}
			// 客戶tab
		} else if (nextProps.selectedItemId) {
			if (nextProps.selectedItemId !== this.props.selectedItemId) {
				this.loadData(nextProps.selectedItemId)
			}
		}
	}

	componentDidUpdate(prevProps, prevState) {
		let mode;
		if ((this.props.params && this.props.params.id) || this.props.selectedItemId) {
			// 編輯情境
			mode = 'edit';
		} else {
			// 新增情境
			mode = 'add';
		}

		const
			// {
			// 	optsMchineType_sales,
			// 	optsMchineType_svc
			// } = this.props,
			{
				quotation_bTypeId,
				quotation_bStageId,
				quotation_bTakeId,
				quotation_bDeliveryId,
				repair_man_id,
				quotation_creatorId,
				quotation_bModelId,
				company,
				contact,
				quotation_bCurrencyId,
				quotation_bTaxId,
				quotation_bMachineType,
				quotation_brandId,
				quotation_dealAmount,
				btnSaveDisable
			} = this.state;

		// switch (mode) {
		// 	case 'add':
		// 		if (!quotation_bMachineType) {
		// 			switch (quotation_bTypeId) {
		// 				case '1':
		// 					this.setState({ quotation_bMachineType: optsMchineType_sales.length > 0 ? optsMchineType_sales[0].value : '1' })
		// 					break;
		// 				case '2':
		// 					this.setState({ quotation_bMachineType: optsMchineType_svc.length > 0 ? optsMchineType_svc[0].value : '1' })
		// 					break;

		// 				default:
		// 			}
		// 		}
		// 		// 表單類型
		// 		if (prevState.quotation_bTypeId !== quotation_bTypeId) {
		// 			if (quotation_bTypeId === '1') this.setState({ quotation_bStageId: '1', quotation_bMachineType: '2' })
		// 			else if (quotation_bTypeId === '2') this.setState({ quotation_bStageId: '1', quotation_bMachineType: '1' })
		// 			// 金額明細的備註 規則
		// 			this.handlers.onChangePaymentRemark();
		// 		}
		// 		// 產品類型
		// 		if (prevState.quotation_bMachineType !== quotation_bMachineType) {
		// 			// 金額明細的備註 規則
		// 			this.handlers.onChangePaymentRemark();
		// 		}
		// 		// 案況進度
		// 		if (prevState.quotation_bStageId !== quotation_bStageId) {
		// 			if (quotation_bStageId === '1') this.setState({ quotation_bMachineType: '2' })
		// 			else this.setState({ quotation_bMachineType: '1' })
		// 		}
		// 		break;

		// 	default:
		// }


		// 客製零件編號array
		// if ( is_parts_data_loaded && !is_parts_data_loaded_for_state && is_loaded ) {

		// 	let new_data = parts_data.map((x, y)=>{ return { part_id: x.part_id, part_name: x.part_name, label:  x.part_id + ' - ' + x.part_name, price: x.unit_price, part_spec: x.part_spec } })

		// 	parts.map((x, y)=>{

		// 		if ( x.number !== null ) {

		// 			let find_data = _.find( new_data, { part_id: x.number.part_id } )
		// 			if ( find_data === undefined ) {
		// 				new_data.push({ part_id: x.number.part_id, part_name: x.name, label:  x.number.part_id + ' - ' + x.name, price: x.price, part_spec: x.part_spec, disabled: true })
		// 			}
		// 			else {
		// 				find_data.disabled = true
		// 			}
		// 		}
		// 	})
		// 	this.setState({ parts_data_for_number: new_data, is_parts_data_loaded_for_state: true })
		// }
		if (
			!quotation_bTypeId ||
			!quotation_bStageId ||
			!quotation_bTakeId ||
			!quotation_bDeliveryId ||
			!repair_man_id ||
			!quotation_creatorId ||
			!quotation_bModelId ||
			!company ||
			!contact ||
			!quotation_bCurrencyId ||
			!quotation_bTaxId ||
			!quotation_bMachineType ||
			!quotation_brandId.length ||
			quotation_dealAmount === ''
		) {
			if (!btnSaveDisable) {
				this.setState({ btnSaveDisable: true });
			}
		} else if (btnSaveDisable) {
			this.setState({ btnSaveDisable: false });
		}
	}

	loadData(id, cb) {
		// 以下cb的配置是為確保此處所有ajax完成之後再執行
		$.ajax({
			type: 'get',
			url: `/api/M_Quotation_Data_Get.php?doc_id=${id}`,
			success: res => {
				if (res.status == 0) {
					const result = res.result;

					this.setState({
						repair_man_id: result.request_id,
						repair_man_name: result.request_name,
						quotation_status: result.review_status_id,
						quotation_customerId: result.customer_id,
						// quotation_customerName: result.customer_name,
						company: { id: result.company_id, name: result.customer_name },
						contact: { id: result.contact_id, name: result.contact_name },
						// contact_data: { contact_id: result.contact_id, contact_name: result.contact_name },
						address: result.customer_address,
						contact_tel: result.contact_tel,
						// contact_mobile: result.contact_mobile,
						contact_email: result.contact_email,
						quotation_docId: result.doc_id,
						quotation_bTypeId: result.b_type_id,
						quotation_bStageId: result.b_stage_id,
						quotation_bTakeId: result.b_take_id,
						quotation_bModelId: result.b_model_id,
						quotation_creatorId: result.creator_id,
						quotation_creatorName: result.creator_name,
						quotation_quotationDate:
							(
								result.quotation_date !== '' &&
								result.quotation_date !== '0000-00-00 00:00:00'
							) ? moment(result.quotation_date) : null,
						quotation_expiryDate:
							(
								result.expiry_date !== '' &&
								result.expiry_date !== '0000-00-00 00:00:00'
							) ? moment(result.expiry_date) : null,
						quotation_bDeliveryId: result.b_delivery_id,
						quotation_bCurrencyId: result.b_currency_id,
						quotation_bTaxId: result.b_tax_id,
						quotation_bMachineType: result.b_machine_type,
						quotation_brandId: result.brand_id.split(','),
						quotation_subcost: removeCommasToNumber(result.subcost * 1 || 0),
						quotation_totalAmount: removeCommasToNumber(result.total_amount * 1 || 0),
						quotation_dealAmount: removeCommasToNumber(result.deal_amount * 1 || 0),
						quotation_paymentId: result.payment_id,
						quotation_paymentRemark: result.payment_remark,
						quotation_productRemark: result.product_remark,
						machine_name: result.machine_name,
						machine_model: result.machine_model,
						serial_number: result.machine_number,
						// 	canEdit: result.status === '3' ? false : true,
						// 批次匯出pdf情況下，全部完成才從別處取消讀取動畫
						is_loaded:
							(
								this.props.params &&
								(
									this.props.params.id === 'pdf-export-withoutphoto' ||
									this.props.params.id === 'pdf-export'
								)
							) ? false : true
					}, null);

					// 廠區
					// this.loadFactoryData(result.company_id)
					// 聯絡人
					// if (result.factory_id === '0') {
					this.loadContactData(result.company_id, result.contact_id, cb);
					// } else {
					// this.onChangeFactory(result.factory_id, 1);
					// }

					// // 附件處理
					// let repair_orinFiles =
					// 	(result.issue_images || [])
					// 		.concat(result.issue_pdfs || [])
					// 		.concat(result.issue_videos || [])
					// 		.concat(result.issue_words || [])
					// 		.concat(result.issue_excels || [])
					// 		.concat(result.issue_powerpoints || []),
					// 	maintain_orinFiles =
					// 		(result.solution_images || [])
					// 			.concat(result.solution_pdfs || [])
					// 			.concat(result.solution_videos || [])
					// 			.concat(result.solution_words || [])
					// 			.concat(result.solution_excels || [])
					// 			.concat(result.solution_powerpoints || []),
					// 	repair_downloadedFiles = this.fileFilter(repair_orinFiles),
					// 	maintain_downloadedFiles = this.fileFilter(maintain_orinFiles);

					// onFileDrop2(repair_downloadedFiles, '', this, true, '', 'repair_preview');
					// onFileDrop2(maintain_downloadedFiles, '', this, true, '', 'maintain_preview');
				} else this.props.closeModal()
			},
			error: (xhr, ajaxOptions, thrownError) => { }
		});
		// 產品明細
		$.ajax({
			type: 'get',
			url: `/api/M_Quotation_Data_Detail_Get.php?doc_id=${id}`,
			success: res => {
				if (res.status == 0) {
					const result = res.result;

					let parts = [];
					_.forEach(result, (val, key) => {
						$.ajax({
							type: 'get',
							url: `/api/M_Product_Jnh_Search_Get.php?product_id=${val.product_id}`,
							async: false,
							success: res => {
								const result_data =
									res.status === '0'
										? res.result
										: [];

								if (result_data.length > 0) {
									let tmp = {};
									tmp['id'] = val.item;
									tmp['partId'] = val.product_id;
									tmp['partName'] = '';
									tmp['partSpec'] = val.spec;
									tmp['partSpecEname'] = val.spec_ename;
									tmp['details'] = val.spec_details;
									tmp['quantity'] = removeCommasToNumber(val.quantity);
									tmp['bUnitId'] = val.b_unit_id;
									tmp['warrantyPeriod'] = val.warranty_period;

									tmp['cost'] = removeCommasToNumber(val.cost);
									tmp['cost_orig'] = removeCommasToNumber(result_data[0].purchase_price);
									tmp['price'] = removeCommasToNumber(val.price);
									tmp['price_orig'] = removeCommasToNumber(result_data[0].list_price);

									tmp['unitPrice'] = removeCommasToNumber(val.unit_price);
									tmp['extraCost'] = removeCommasToNumber(val.extra_cost);
									tmp['averageUnitPrice'] = removeCommasToNumber(val.average_unit_price);
									tmp['subtotal'] = removeCommasToNumber(val.subtotal);
									tmp['remark'] = val.remark || '';
									tmp['displayId'] = val.display_id || '0';
									tmp['is_double'] = false;

									parts.push(tmp)
								}
							},
							error: (xhr, ajaxOptions, thrownError) => { }
						})
					});
					this.setState({ parts, parts_orig: parts });
				}
			},
			error: (xhr, ajaxOptions, thrownError) => { }
		});
	}

	loadFactoryData(company_id) {
		const { factory_data } = this.props,
			result_data =
				_.filter(factory_data, { company_id: company_id }) &&
					_.filter(factory_data, { company_id: company_id }).length > 0
					? _.filter(factory_data, { company_id: company_id })
					: [];
		this.setState({ factory_data: result_data })
	}

	loadContactData(company_id, contact_id, cb) {
		$.ajax({
			type: 'get',
			url: `/api/M_SaleSky_Contacts.php?company_id=${company_id}`,
			success: res => {
				const result_data =
					res.status === '0'
						? res.result
						: [];

				this.setState({ contact_data: result_data }, cb);

				if (result_data.length > 0) {
					const contact = _.find(result_data, { id: contact_id });

					this.onChangeContact(contact_id !== '0' && contact ? contact : result_data[0]);
				} else this.onChangeContact(null);
			},
			error: (xhr, ajaxOptions, thrownError) => { }
		})
	}
	// loadContactData(customer_id, contact_id, contact_name, cb) {
	// 	$.ajax({
	// 		type: 'get',
	// 		url: `/api/M_Contacts_ByName_Get.php?contact_name=${contact_name}`,
	// 		success: res => {
	// 			const result_data =
	// 				res.status === '0'
	// 					? _.filter(res.result, { customer_id })
	// 					: [];

	// 			this.setState({ contact_data: result_data }, cb);

	// 			if (result_data.length > 0) {
	// 				const contact = _.find(result_data, { contact_id });

	// 				this.onChangeContact(contact_id !== '0' && contact ? contact || {} : result_data[0]);
	// 			} else this.onChangeContact(null);
	// 		},
	// 		error: (xhr, ajaxOptions, thrownError) => { }
	// 	})
	// }

	// loadProductData(id) {
	// 	$.ajax({
	// 		type: 'get',
	// 		url: `/api/M_SaleSky_ShippingRecord_Get.php?company_id=${id}`,
	// 		success: res => {
	// 			this.setState({ product_data: res.result, product_model: null });
	// 		},
	// 		error: (xhr, ajaxOptions, thrownError) => { }
	// 	});
	// }

	// timeOption(unit) {
	// 	let array = [];
	// 	for (let i = 0; i < unit; i++) {
	// 		i < 10 ? array.push(`0${i}`) : array.push(i.toString())
	// 		// array.push(i.toString())
	// 	}

	// 	return array.map((x, y) => <option key={y} value={x}>{x}</option>)
	// }

	onChangeRepairMan(option) {
		const repair_man_id = (option === null || option.length === 0) ? '' : option.id,
			repair_man_name = (option === null || option.length === 0) ? '' : option.name;

		this.setState({ repair_man_id, repair_man_name })
	}
	onChangeCreatorMan(option) {
		const quotation_creatorId = (option === null || option.length === 0) ? '' : option.id,
			quotation_creatorName = (option === null || option.length === 0) ? '' : option.name;

		this.setState({ quotation_creatorId, quotation_creatorName })
	}

	onChangeCompany(option) {
		let
			company_id = (option === null || option.length === 0) ? '' : option.id,
			// company_name = (option === null || option.length === 0) ? '' : option.name,
			address = (option === null || option.length === 0) ? '' : option.address.street || option.address;
		this.setState({
			company: option,
			address,
			factory: '0',
			contact: { id: option.contact_id, name: option.contact_name },
			// contact_data: { contact_id: option.contact_id, contact_name: option.contact_name },
		})

		this.loadContactData(company_id, option.contact_id ? option.contact_id : '');
		// this.loadFactoryData(company_id);
	}

	onChangeFactory(value, keepInfo) {
		if (value === '0') {
			this.loadContactData(this.state.company.id);

			// 清空資訊
			this.setState({
				contact: null,
				contact_tel: '',
				contact_mobile: '',
				contact_email: '',
				factory: value,
				address: this.state.company.address
			});
			return;
		}

		const { factory_data } = this.props;

		let find_data = _.find(factory_data, { company_id: this.state.company.id, factory_id: value }),
			address = find_data === undefined ? '' : find_data.address,
			contacts = find_data === undefined ? [] : find_data.contacts;

		contacts.map((x, y) => {
			x.id = x.contact_id || x.id;
			x.name = x.contact_name || x.name;
			return x
		})

		const contact = keepInfo ? {} : { contact: null };

		this.setState({ factory: value, address: address, ...contact, contact_data: contacts })

		if (keepInfo) return;
		this.onChangeContact(null)
	}

	onChangeContact(option) {
		let is_error = false, email = '', work_phone = '', cell_phone = '';

		if (option !== null && option.length !== 0) {
			email = option.email
			work_phone = option.contact_work_phone
			cell_phone = option.cell_phone
		} else option = null

		is_error =
			option === null ? true : false;

		this.setState({
			contact: option || {},
			contact_tel: work_phone || '',
			contact_mobile: cell_phone || '',
			contact_email: email || '',
			is_error
		})
	}

	// onChangeTotalAmount() {
	// let { parts } = this.state;

	// 	let parts_total = 0, tax_total = 0;
	// 	parts.map((x, y) => parts_total += parseInt(x.subtotal, 10))
	// 	let subtotal = (parts_total === '' ? 0 : parseInt(parts_total, 10)) + (car_cost === '' ? 0 : parseInt(car_cost, 10)) + (working_cost === '' ? 0 : parseInt(working_cost, 10)) + (service_cost === '' ? 0 : parseInt(service_cost, 10)) - discount;
	// 	// let subtotal = (car_cost === '' ? 0 : parseInt(car_cost, 10)) + (working_cost === '' ? 0 : parseInt(working_cost, 10)) + (service_cost === '' ? 0 : parseInt(service_cost, 10)) - discount;
	// 	if (subtotal < 0) subtotal = 0;

	// 	tax_total = Math.round(subtotal * (tax / 100));

	// 	let total_amount = subtotal * (1 + tax / 100)
	// 	total_amount = Math.round(total_amount)

	// 	this.setState({ subtotal: subtotal, total_amount: total_amount, parts_total, tax_total })
	// }

	// onChangePartNumber(option, index) {
	// 	// const { parts_data } = this.props
	// 	const { parts, parts_data_for_number } = this.state

	// 	// 解除disable
	// 	if (parts[index].number !== null) {

	// 		let find_data = _.find(parts_data_for_number, { part_id: parts[index].number.part_id })
	// 		find_data === undefined ? null : find_data.disabled = false
	// 	}

	// 	// 檢查option值 必須先檢查是否為null
	// 	if (option !== null) {

	// 		// 檢查是否為空值
	// 		if (option.length === 0) option = null;
	// 		else {
	// 			option.disabled = true
	// 			// parts[index].name = _.find( parts_data_for_number, { part_id: option.part_id } ) !== undefined ? option.part_name : null
	// 			parts[index].part_name = option.part_name || ''
	// 			parts[index].price = option.price || 0
	// 			parts[index].part_spec = option.part_spec || ''
	// 			parts[index].qty = '1'
	// 			parts[index].total = option.price || 0
	// 		}
	// 	}

	// 	if (option === null) {

	// 		parts[index].name = ''
	// 		parts[index].price = '0'
	// 		parts[index].part_spec = ''
	// 		parts[index].qty = '0'
	// 		parts[index].total = '0'
	// 	}

	// 	let is_error = false
	// 	// 是否重複或空值
	// 	if (_.find(parts, { number: option }) !== undefined) {

	// 		is_error = true
	// 	}

	// 	parts[index].is_double = _.find(parts, { number: option }) === undefined ? false : true
	// 	parts[index].number = option
	// 	// let pulled = _.pull( parts_data, option )

	// 	this.setState({ parts: parts, is_error: is_error })
	// 	this.onChangeTotalAmount()
	// }

	// onChangePartName ( option, index ) {

	// 	const { parts } = this.state

	// 	// 檢查option值 必須先檢查是否為null
	// 	if ( option !== null ) {
	// 		// 檢查是否為空值
	// 		if ( option.length === 0 ) {
	// 			// 改成null
	// 			option = null
	// 		}
	// 	}

	// 	parts[index].name = option

	// 	this.setState({ parts: parts })
	// }

	onPageChange(direction) {
		const { filter_data, params, selectedItemId, selectedRowIndex, parentStateHandler } = this.props

		let data_length = filter_data.length,
			id = params ? params.id : selectedItemId;
		if (direction === 'next') {
			let find_index = _.findIndex(filter_data, { doc_id: id });
			id = find_index < data_length - 1 ? filter_data[(find_index + 1)].doc_id : id
		} else if (direction === 'prev') {
			let find_index = _.findIndex(filter_data, { doc_id: id });
			id = find_index > 0 ? filter_data[(find_index - 1)].doc_id : id
		}

		if (this.props.params) browserHistory.push(`/salesky/form-quotation/${id}`);
		else this.loadData(id);

		// 更新選定id以及row
		if (!params) {
			const row = direction === 'next' ? selectedRowIndex + 1 : selectedRowIndex - 1;

			if (row < 0) row = 0;
			else if (row > data_length - 1) row = data_length - 1;

			parentStateHandler({
				states: ['selectedItemId', 'selectedRowIndex'],
				newValues: [id, row]
			});
		}
	}

	onSubmit() {
		let mode;
		// 編輯情境
		if ((this.props.params && this.props.params.id) || this.props.selectedItemId) {
			mode = 'edit';
			// 新增情境
		} else mode = 'add';

		const {
			repair_man_id,
			repair_man_name,
			quotation_status,
			quotation_customerId,
			// quotation_customerName,
			company,
			contact,
			address,
			contact_tel,
			// contact_mobile,
			contact_email,
			quotation_docId,
			quotation_bTypeId,
			quotation_bStageId,
			quotation_bTakeId,
			quotation_bModelId,
			quotation_creatorId,
			quotation_creatorName,
			quotation_quotationDate,
			quotation_expiryDate,
			quotation_bDeliveryId,
			quotation_bCurrencyId,
			quotation_bTaxId,
			quotation_bMachineType,
			quotation_brandId,
			quotation_subcost,
			quotation_totalAmount,
			quotation_dealAmount,
			quotation_paymentId,
			quotation_paymentRemark,
			quotation_productRemark,
			machine_name,
			machine_model,
			serial_number
		} = this.state;

		let formData = new FormData();
		formData.append('request_id', repair_man_id || this.props.user_id);				//申請人ID
		formData.append('request_name', repair_man_name || this.props.user_name);		//申請人
		// =======================================================
		formData.append('status', quotation_status);
		// formData.append('company_id', company ? company.id : '');
		formData.append('customer_id', quotation_customerId);
		formData.append('customer_name', company ? company.name : '');
		formData.append('customer_address', address);
		formData.append('contact_id', contact ? contact.id || contact.contact_id : '');
		formData.append('contact_name', contact ? contact.name || contact.contact_name : '');
		formData.append('contact_tel', contact_tel);
		// formData.append('contact_mobile', contact_mobile);
		formData.append('contact_email', contact_email);

		formData.append('b_type_id', quotation_bTypeId);
		formData.append('b_stage_id', quotation_bStageId);
		formData.append('b_take_id', quotation_bTakeId);
		formData.append('b_model_id', quotation_bModelId);

		if (quotation_quotationDate !== null) formData.append('quotation_date', quotation_quotationDate !== null ? quotation_quotationDate.format('YYYY-MM-DD') : '');
		if (quotation_expiryDate !== null) formData.append('expiry_date', quotation_expiryDate !== null ? quotation_expiryDate.format('YYYY-MM-DD') : '');

		formData.append('machine_model', machine_model);
		formData.append('machine_name', machine_name);
		formData.append('machine_number', serial_number);

		formData.append('b_delivery_id', quotation_bDeliveryId);
		formData.append('b_currency_id', quotation_bCurrencyId);
		formData.append('b_tax_id', quotation_bTaxId);
		formData.append('b_machine_type', quotation_bMachineType);
		formData.append('brand_id', quotation_brandId.join());
		formData.append('subcost', quotation_subcost);
		formData.append('total_amount', quotation_totalAmount);
		formData.append('deal_amount', quotation_dealAmount);
		formData.append('payment_id', quotation_paymentId);
		formData.append('payment_remark', quotation_paymentRemark);
		formData.append('product_remark', quotation_productRemark);

		// formData.append('parts_list', new_parts);	// 原本是parts_list

		// if (newParts.length > 0) {
		// 	_.forEach(newParts, (val, key) => {
		// 		formData.append(`parts_list[${key}][item]`, val.id);
		// 		formData.append(`parts_list[${key}][product_id]`, val.partId);
		// 		formData.append(`parts_list[${key}][spec]`, val.partSpec || '');
		// 		formData.append(`parts_list[${key}][spec_ename]`, val.partSpecEname || '');
		// 		formData.append(`parts_list[${key}][spec_details]`, val.details || '');
		// 		formData.append(`parts_list[${key}][quantity]`, val.quantity || 0);
		// 		formData.append(`parts_list[${key}][b_unit_id]`, val.bUnitId || '1');
		// 		formData.append(`parts_list[${key}][warranty_period]`, val.warrantyPeriod || '0');
		// 		formData.append(`parts_list[${key}][cost]`, val.cost || 0);
		// 		formData.append(`parts_list[${key}][price]`, val.price || 0);
		// 		formData.append(`parts_list[${key}][unit_price]`, val.unitPrice || 0);
		// 		formData.append(`parts_list[${key}][extra_cost]`, val.extraCost || 0);
		// 		formData.append(`parts_list[${key}][average_unit_price]`, val.averageUnitPrice || 0);
		// 		formData.append(`parts_list[${key}][subtotal]`, val.subtotal || 0);
		// 		formData.append(`parts_list[${key}][display_id]`, val.displayId || '0');
		// 	});
		// }

		switch (mode) {
			case 'add':
				formData.append('creator_id', quotation_creatorId);
				formData.append('creator_name', quotation_creatorName);
				break;
			case 'edit':
				formData.append('doc_id', quotation_docId);
				break;

			default:
		}

		// 不存在的聯絡人先新增(停用)
		// if (contact.className) {
		// 	const contactFormData = new FormData();

		// 	let url, nameKey;
		// 	if (this.state.factory === '0') {
		// 		url = 'W_SaleSky_Contacts_Post.php';
		// 		nameKey = 'name';
		// 	} else {
		// 		url = 'W_ServiceSky_Factory_Contacts_Post.php';
		// 		nameKey = 'contact_name';
		// 		contactFormData.append('factory_id', this.state.factory);
		// 	}

		// 	contactFormData.append(nameKey, contact.name);
		// 	contactFormData.append('company_id', company.id);
		// 	contactFormData.append('work_phone', this.state.contact_tel || '');
		// 	contactFormData.append('cell_phone', this.state.contact_mobile || '');
		// 	contactFormData.append('email', this.state.contact_email || '');

		// 	$.ajax({
		// 		type: 'post',
		// 		url: `/api/${url}`,
		// 		data: contactFormData,
		// 		processData: false,
		// 		contentType: false,
		// 		success: res => {
		// 			if (res.status === '0') {
		// 				const newContact = res.result[0];

		// 				if (this.state.factory !== '0') {
		// 					const { factory_data } = this.props

		// 					const find_data =
		// 						_.find(factory_data, { factory_id: this.state.factory }),
		// 						ind = _.findIndex(find_data.contacts, { id: contact.name });

		// 					find_data.contacts.splice(ind, 1, newContact);
		// 				}

		// 				formData.append('contact_id', newContact.id || newContact.contact_id);
		// 				this.doSaveAJAX(formData);
		// 			}
		// 		},
		// 		error: error => { }
		// 	});
		// } else {
		// 	formData.append('contact_id', contact.id);
		// 	this.doSaveAJAX(formData);
		// }
		this.doSaveAJAX(formData);
	}

	uploadFiles(type, id) {
		this.refs.uploading.style.display = 'inline-block';

		const { repair_content_files, maintain_content_files } = this.state;

		let upload_files = []
		if (type === 'RepairIssue')
			upload_files = repair_content_files
		else if (type === 'RepairSolution')
			upload_files = maintain_content_files

		let fileData = new FormData()
		fileData.append('type', type)
		fileData.append('file_id', id);

		for (let i = 0; i < upload_files.length; i++) {
			fileData.append('$_FILES', upload_files[i])

			$.ajax({
				async: false,
				type: 'POST',
				data: fileData,
				processData: false,
				contentType: false,
				url: '/api/M_SaleSky_FileUpload_Post.php',
				success: res => { },
				error: (xhr, ajaxOptions, thrownError) => { }
			});
		}

		this.refs.uploading.style.display = 'none';
		// this.props.closeModal();
	}

	deleteFiles(type, id) {
		this.refs.uploading.style.display = 'inline-block';

		const { delete_repair_files, delete_maintain_files } = this.state;

		let delete_files = [];
		if (type === 'RepairIssue') delete_files = delete_repair_files
		else if (type === 'RepairSolution') delete_files = delete_maintain_files

		let fileData = new FormData()
		fileData.append('type', type)

		for (let i = 0; i < delete_files.length; i++) {
			fileData.append('id', delete_files[i].file_id)

			$.ajax({
				async: false,
				type: 'POST',
				data: fileData,
				processData: false,
				contentType: false,
				url: '/api/M_SaleSky_FileDelete_Post.php',
				success: res => { },
				error: (xhr, ajaxOptions, thrownError) => { }
			});
		}

		this.refs.uploading.style.display = 'none'
		// this.props.closeModal();
	}

	addPart() {
		const { parts } = this.state;

		parts.push(Object.assign({}, part_obj))
		this.setState({ parts })
	}

	removePart(index) {
		const { parts } = this.state;

		let newPartsList = _.filter(parts, function (n) { return n.itemFlag !== 'delete'; });
		newPartsList[index].itemFlag = 'delete';
		_.uniq(parts, newPartsList);

		this.setState({ parts })
	}

	// isEmail(email) {
	// 	var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
	// 	return re.test(email);
	// }

	// addLeftZero(str, length) {
	// 	return new Array(length - str.length + 1).join('0') + str;
	// }

	// formatInt(value) {
	// 	const value_ = removeCommasToNumber(value).toString();

	// 	let int_value = value_.replace(/\D/g, '');
	// 	return int_value === '' ? 0 : parseInt(int_value, 10).toString();
	// }

	filterOptions(optsObjArr, stringFilter, selectedOptions) {
		const vaildOptions = _.difference(optsObjArr, selectedOptions);
		// 轉小寫的選項arr應該以state存起來避免每次重運算，只在opts更新時做更新
		// 如果運算loading相對小，不儲存可以節省記憶體，依情境取捨
		let filteredOptsObjArr = [];
		if (stringFilter) {
			let stringFilterLowerCase = stringFilter.toLowerCase();

			_.forEach(vaildOptions, (val, key) => {
				if (
					(
						val.name &&
						val.name.toLowerCase().indexOf(stringFilterLowerCase) !== -1
					) ||
					(
						val.label &&
						val.label.toLowerCase().indexOf(stringFilterLowerCase) !== -1
					)
				) {
					filteredOptsObjArr.push(val);
				}
			});
		} else {
			filteredOptsObjArr = vaildOptions;
		}

		return filteredOptsObjArr;
	}

	render() {
		const { languageData, languageCode } = window.myConsts;

		const {
			closeModal,
			repair_man_data,
			assign_data,
			company_data,
			factory_data,
			area_data,
			optsReviewStatus,
			optsTypeStatus,
			optsStage,
			optsTake,
			optsModelStatus,
			optsDelivery,
			optsCurrency,
			optsTax,
			optsMchineType_sales,
			optsMchineType_svc,
			optsBrand,
			optsUnit,
			optsPaymentRemark
		} = this.props;

		const {
			enableEdit,
			is_loaded,
			quotation_customerId,
			// quotation_customerName,
			company,
			address,
			contact,
			contact_data,
			contact_tel,
			contact_email,
			repair_man_id,
			repair_man_name,
			quotation_status,
			quotation_docId,
			quotation_bTypeId,
			quotation_bStageId,
			quotation_bTakeId,
			quotation_bModelId,
			quotation_creatorId,
			quotation_creatorName,
			quotation_quotationDate,
			quotation_expiryDate,
			quotation_bDeliveryId,
			quotation_bCurrencyId,
			quotation_bTaxId,
			quotation_bMachineType,
			quotation_brandId,
			quotation_subcost,
			quotation_totalAmount,
			quotation_dealAmount,
			quotation_paymentId,
			quotation_paymentRemark,
			quotation_productRemark,
			showSearchCompanyContactModal,
			machine_name,
			machine_model,
			serial_number,
			showSearchSNResult,
			selectSNValue,
			serialNumberList,
			parts,
			canEdit,
			showPdfContent,
			btnSaveDisable
		} = this.state,
			optsWarrantyPeriod = [
				{ value: '0', label: '+0' },
				{ value: '1', label: '+1' },
				{ value: '2', label: '+2' },
				{ value: '3', label: '+3' },
				{ value: '4', label: '+4' },
				{ value: '5', label: '+5' },
				{ value: '6', label: '+6' },
				{ value: '7', label: '+7' },
				{ value: '8', label: '+8' },
				{ value: '9', label: '+9' },
				{ value: '10', label: '+10' }
			];

		let title = '', btnExportPDF, mode,
			repair_man = repair_man_id, creator_man = quotation_creatorId;
		// 編輯情境
		if ((this.props.params && this.props.params.id) || this.props.selectedItemId) {
			mode = 'edit';
			// 新增情境
		} else {
			mode = 'add';
		}

		switch (mode) {
			case 'add':
				title = <div className='textLineHeight' style={{ fontSize: 18, fontWeight: 500 }}>{languageData['461'][languageCode]}</div>;
				creator_man = creator_man || (_.filter(repair_man_data, ['id', this.props.user_id])[0] ? _.filter(repair_man_data, ['id', this.props.user_id])[0].id : '');
				repair_man = repair_man || (_.filter(repair_man_data, ['id', this.props.user_id])[0] ? _.filter(repair_man_data, ['id', this.props.user_id])[0].id : '');
				break;
			case 'edit':
				// 報修人員若不在選單中，新增一筆
				if (_.filter(repair_man_data, ['id', repair_man_id]).length <= 0 && repair_man_id !== '') {
					repair_man_data.push({ 'id': repair_man_id, 'name': repair_man_name, 'group_name': '', 'job_title': '', 'photo': '', 'user_group': '' })
				} else {
					repair_man = _.filter(repair_man_data, ['id', repair_man_id]).length > 0 ? _.filter(repair_man_data, ['id', repair_man_id])[0] : '';
				}
				// 建立者若不在選單中，新增一筆
				if (_.filter(repair_man_data, ['id', quotation_creatorId]).length <= 0 && quotation_creatorId !== '') {
					repair_man_data.push({ 'id': quotation_creatorId, 'name': quotation_creatorName, 'group_name': '', 'job_title': '', 'photo': '', 'user_group': '' })
				} else {
					creator_man = _.filter(repair_man_data, ['id', quotation_creatorId]).length > 0 ? _.filter(repair_man_data, ['id', quotation_creatorId])[0] : '';
				}

				if (!enableEdit) {
					title = <div className='textLineHeight' style={{ fontSize: 18, fontWeight: 500 }}>{languageData['449'][languageCode]}</div>;
					btnExportPDF = <DeleteBtnWithConfirm
						btnTitle={showPdfContent ? languageData['474'][languageCode] : languageData['473'][languageCode]}
						title={languageData['411'][languageCode]}
						style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}
						onClick={this.onExportPdfWithPhotoClick}
						onCancelClick={this.onExportPdfWithoutPhotoClick} />;

				} else {
					title = <div className='textLineHeight' style={{ fontSize: 18, fontWeight: 500 }}>{languageData['77'][languageCode]}</div>;
				}
				break;

			default:
		}

		// canEdit 依據是否已結案，editPermission 依據權限
		const editPermission = this.props.userPermission.salesky_quotation_web * 1 > 2,
			// editControl = canEdit && editPermission;
			editControl = true,
			newParts = _.filter(parts, function (o) { return o.itemFlag !== 'delete' });

		let btnSaveDisableStr = '';
		if (!quotation_bTypeId) btnSaveDisableStr += '表單類型、';
		if (!quotation_bStageId) btnSaveDisableStr += '案況進度、';
		if (!quotation_bTakeId) btnSaveDisableStr += '預計取件、';
		if (!quotation_bDeliveryId) btnSaveDisableStr += '取件方式、';
		if (!repair_man) btnSaveDisableStr += '申請人、';
		if (!creator_man) btnSaveDisableStr += '建立者、';
		if (!quotation_bModelId) btnSaveDisableStr += '商業模式、';
		if (!company) btnSaveDisableStr += '客戶全稱、';
		if (!contact) btnSaveDisableStr += '聯絡人、';
		if (!quotation_bCurrencyId) btnSaveDisableStr += '幣別、';
		if (!quotation_bTaxId) btnSaveDisableStr += '稅別、';
		if (!quotation_bMachineType) btnSaveDisableStr += '產品類型、';
		if (!quotation_brandId.length) btnSaveDisableStr += '廠牌、';
		if (quotation_dealAmount === '') btnSaveDisableStr += '預計成交價、';

		let btn_save =
			enableEdit ?
				<Button
					onClick={() => this.onSubmit()}
					disabled={!editControl || btnSaveDisable}
					style={{ position: 'relative' }}>
					{languageData['76'][languageCode]}
					{
						btnSaveDisableStr ?
							<Tooltip
								placement='left'
								tipText={`請檢查 ${btnSaveDisableStr.substr(0, btnSaveDisableStr.length - 1)}`}
								onClick={e => { e.stopPropagation(); }}
							/>
							: ''
					}
				</Button>
				:
				<Button
					onClick={() => this.setState({ enableEdit: true })}
					disabled={!editControl || btnSaveDisable}
					style={{ position: 'relative' }}>
					{languageData['77'][languageCode]}
					{
						!editControl ?
							<Tooltip
								placement='left'
								tipText={canEdit ? '您無編輯權限' : '已結案不可編輯'}
								onClick={e => { e.stopPropagation(); }}
							/>
							: ''
					}
				</Button>

		let btn_copy = enableEdit ? '' : <Button onClick={closeModal} style={{ display: 'none' }}>{languageData['462'][languageCode]}</Button>
		let btn_prev_page = enableEdit ? '' : <Button className='btn_page' onClick={() => this.onPageChange('prev')}>{languageData['450'][languageCode]}</Button>
		let btn_next_page = enableEdit ? '' : <Button className='btn_page' onClick={() => this.onPageChange('next')}>{languageData['451'][languageCode]}</Button>
		let btn_cancel_text = enableEdit ? languageData['55'][languageCode] : languageData['452'][languageCode]


		let repairPdfContent = null;
		if (showPdfContent) {
			repairPdfContent = this.pdfContentCreater();
		}

		// 匯出pdf時不顯示ui
		let isPDFBatchExport;
		if (mode !== 'add') {
			if (
				(
					this.props.params &&
					(
						this.props.params.id === 'pdf-export' ||
						this.props.params.id === 'pdf-export-withoutphoto'
					)
				) ||
				this.props.selectedItemId.indexOf('pdfBacthExport') !== -1
			) {
				isPDFBatchExport = true;
			}
		}

		return (
			<div>
				<div ref='uploading' className='loading' style={{ display: is_loaded ? 'none' : 'flex' }}>
					<img role='presentation' src='/imgs/loading.gif' />
				</div>

				<Modal style={isPDFBatchExport ? { display: 'none' } : null} onHide={closeModal} className='modal_online_repair' keyboard={false} backdrop='static' show={true} bsSize='large'>
					<Modal.Header>
						<div className='modal_title'>{title}</div>
						<div style={{ justifyContent: 'center' }}>
							{btn_prev_page}
							{btn_next_page}
						</div>
						<div style={{ justifyContent: 'flex-end' }}>
							{btn_save}
							{/* {btnExportPDF}
							{btn_copy} */}
							<Button onClick={closeModal}>{btn_cancel_text}</Button>
						</div>
					</Modal.Header>
					<Modal.Body>
						<Row>
							<Col sm={12}>
								<div style={{ marginBottom: 5, fontWeight: 'Bold' }}>{'估價單編號 '}<span style={{ color: '#ff0000' }}>{quotation_docId}</span></div>
							</Col>
							<Col sm={12}>
								<div style={{ marginBottom: 5, fontWeight: 'Bold' }}>{'基本資料'}</div>
							</Col>
							<Col sm={12}>
								<Well style={{ marginBottom: 15 }}>
									<Row>
										<DropDownMenu
											sm={3}
											required={true}
											label={'表單類型'}
											disabled={!enableEdit}
											stateName='quotation_bTypeId'
											value={quotation_bTypeId}
											// valueKey='id'
											// labelKey='name'
											onChange={(option) => {
												if (option.value === '1' || option.value === '2') {
													this.setState({
														quotation_bTypeId: option.value,
														quotation_bStageId: '1',
														quotation_bMachineType: option.value === '1' ? '2' : option.value === '2' ? '1' : ''
													}, () => {
														// 金額明細的備註 規則
														this.handlers.onChangePaymentRemark();
													})
												} else this.setState({ quotation_bTypeId: option.value }, () => {
													// 金額明細的備註 規則
													this.handlers.onChangePaymentRemark();
												})
											}}
											options={optsTypeStatus} />
										<DropDownMenu
											sm={6}
											required={true}
											label={'案況進度'}
											disabled={!enableEdit || quotation_bTypeId === '2'}
											stateName='quotation_bStageId'
											value={quotation_bStageId}
											// valueKey='id'
											// labelKey='name'
											onChange={(option) => {
												this.setState({
													quotation_bStageId: option.value,
													quotation_bMachineType: option.value === '1' ? '2' : '1'
												}, () => {
													// 金額明細的備註 規則
													this.handlers.onChangePaymentRemark();
												})
											}}
											options={optsStage}
											filterOptions={this.filterOptions} />
										<DropDownMenu
											sm={3}
											label={'狀態'}
											disabled={!enableEdit || mode === 'add'}
											stateName='quotation_status'
											value={quotation_status}
											// valueKey='flowstatus_id'
											// labelKey='flowstatus_name'
											onChange={(option) => this.setState({ quotation_status: option.value })}
											options={optsReviewStatus}
											filterOptions={this.filterOptions} />
									</Row>
									<Row>
										<DropDownMenu
											sm={3}
											required={true}
											label={'預計取件'}
											disabled={!enableEdit}
											stateName='quotation_bTakeId'
											value={quotation_bTakeId}
											// valueKey='flowstatus_id'
											// labelKey='flowstatus_name'
											onChange={(option) => this.setState({ quotation_bTakeId: option.value })}
											options={optsTake}
											filterOptions={this.filterOptions} />
										<DropDownMenu
											sm={3}
											required={true}
											label={'取件方式'}
											disabled={!enableEdit}
											stateName='quotation_bDeliveryId'
											value={quotation_bDeliveryId}
											// valueKey='flowstatus_id'
											// labelKey='flowstatus_name'
											onChange={(option) => this.setState({ quotation_bDeliveryId: option.value })}
											options={optsDelivery}
											filterOptions={this.filterOptions} />
										<DropDownMenu
											sm={3}
											required={true}
											label={'申請人'}
											disabled={!enableEdit}
											stateName='repair_man'
											value={repair_man}
											valueKey='id'
											labelKey='name'
											onChange={(option) => this.onChangeRepairMan(option)}
											options={repair_man_data}
											filterOptions={this.filterOptions} />
										<DropDownMenu
											sm={3}
											required={true}
											label={'建立者'}
											disabled={true}
											stateName='creator_man'
											value={creator_man}
											valueKey='id'
											labelKey='name'
											// onChange={(option) => this.onChangeCreatorMan(option)}
											options={repair_man_data}
											filterOptions={this.filterOptions} />
									</Row>
									{
										quotation_bTypeId === '2' ?
											<Row>
												<Col sm={6}>
													<FormGroup controlId='machine_name'>
														<ControlLabel style={{ fontWeight: 'bold' }}>{'儀器名稱'}</ControlLabel>
														<FormControl
															disabled={!enableEdit}
															type='text'
															onChange={this.handlers.textInputOnChange}
															value={machine_name}
															style={{ height: 36 }} />
													</FormGroup>
												</Col>
												<Col sm={3}>
													<FormGroup controlId='machine_model'>
														<ControlLabel style={{ fontWeight: 'bold' }}>{'儀器型號'}</ControlLabel>
														<FormControl
															disabled={!enableEdit}
															type='text'
															onChange={this.handlers.textInputOnChange}
															value={machine_model}
															style={{ height: 36 }} />
													</FormGroup>
												</Col>
												<Col sm={3}>
													<FormGroup controlId='serial_number' style={{ position: 'relative' }}>
														<ControlLabel style={{ fontWeight: 'bold' }}>{'儀器序號'}</ControlLabel>
														<FormControl
															disabled={!enableEdit}
															type='text'
															onChange={this.handlers.textInputOnChange}
															value={serial_number}
															style={{ height: 36 }} />
														{
															enableEdit && serial_number ?
																<img role='img' src='/imgs/ic_search_nor.svg' alt='' className='text-center'
																	style={{ position: 'absolute', top: 30, right: 5, width: 25, height: 25, cursor: 'pointer' }} onClick={() => { this.handlers.onSNLoadCompanyData() }} />
																: null
														}
													</FormGroup>
												</Col>
											</Row>
											: ''
									}
									<Row>
										<Col sm={3}>
											<FormGroup controlId='quotation_customerId'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'客戶編號'}</ControlLabel>
												<FormControl
													disabled={true}
													type='text'
													// onChange={this.handlers.textInputOnChange}
													value={quotation_customerId}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
										<DayPicker
											labelFontWeight='bold'
											sm={3}
											outerLabel={'報價日期'}
											disabled={!enableEdit}
											onChange={(date) => {
												this.setState({
													quotation_quotationDate: date,
													quotation_expiryDate: date ? moment(date).add(30, 'd') : null
												})
											}}
											dayStateName='quotation_quotationDate'
											dayValue={quotation_quotationDate} />
										<DayPicker
											labelFontWeight='bold'
											sm={3}
											outerLabel={'有效期限'}
											disabled={!enableEdit}
											onChange={(date) => this.setState({ quotation_expiryDate: date })}
											dayStateName='quotation_expiryDate'
											dayValue={quotation_expiryDate} />
										<DropDownMenu
											sm={3}
											required={true}
											label={'商業模式'}
											disabled={!enableEdit}
											stateName='quotation_bModelId'
											value={quotation_bModelId}
											// valueKey='flowstatus_id'
											// labelKey='flowstatus_name'
											onChange={(option) => this.setState({ quotation_bModelId: option.value })}
											options={optsModelStatus}
											filterOptions={this.filterOptions} />
									</Row>
									<Row>
										<DropDownMenu
											sm={6}
											required={true}
											label={'客戶全稱'}
											disabled={!enableEdit}
											stateName='company'
											value={company}
											valueKey='id'
											labelKey='name'
											showSearchCompanyContactModal={(e) => this.handlers.onShowSearchCompanyContactModal(1)}
											onChange={(option) => this.onChangeCompany(option)}
											options={company_data}
											filterOptions={this.filterOptions} />
										<Col sm={6}>
											<FormGroup controlId='address'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'客戶地址'}</ControlLabel>
												<FormControl
													disabled={true}
													type='text'
													// onChange={this.handlers.textInputOnChange}
													value={address}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
									</Row>
									<Row>
										<DropDownMenu
											sm={3}
											required={true}
											label={'聯絡人'}
											disabled={!enableEdit}
											stateName='contact'
											value={contact}
											valueKey='id'
											labelKey='name'
											// valueKey='contact_id'
											// labelKey='contact_name'
											onChange={(option) => this.onChangeContact(option)}
											options={contact_data}
											filterOptions={this.filterOptions} />
										<Col sm={3}>
											<FormGroup controlId='contact_tel'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'聯絡電話'}</ControlLabel>
												<FormControl
													disabled={true}
													type='text'
													// onChange={this.handlers.textInputOnChange}
													value={contact_tel}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
										<Col sm={6}>
											<FormGroup controlId='contact_email'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'Email'}</ControlLabel>
												<FormControl
													disabled={true}
													type='text'
													// onChange={this.handlers.textInputOnChange}
													value={contact_email}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
									</Row>
									<Row>
										<DropDownMenu
											sm={3}
											required={true}
											label={'幣別'}
											disabled={!enableEdit}
											stateName='quotation_bCurrencyId'
											value={quotation_bCurrencyId}
											// valueKey='flowstatus_id'
											// labelKey='flowstatus_name'
											onChange={(option) => this.setState({ quotation_bCurrencyId: option.value })}
											options={optsCurrency}
											filterOptions={this.filterOptions} />
										<DropDownMenu
											sm={3}
											required={true}
											label={'稅別'}
											disabled={!enableEdit}
											stateName='quotation_bTaxId'
											value={quotation_bTaxId}
											// valueKey='flowstatus_id'
											// labelKey='flowstatus_name'
											onChange={(option) => this.setState({ quotation_bTaxId: option.value })}
											options={optsTax}
											filterOptions={this.filterOptions} />
										<DropDownMenu
											sm={6}
											required={true}
											label={'產品類型'}
											disabled={!enableEdit || quotation_bTypeId === '1'}
											stateName='quotation_bMachineType'
											value={quotation_bMachineType}
											// valueKey='flowstatus_id'
											// labelKey='flowstatus_name'
											onChange={(option) => {
												this.setState({ quotation_bMachineType: option.value }, () => {
													// 金額明細的備註 規則
													this.handlers.onChangePaymentRemark();
												})
											}}
											options={
												quotation_bTypeId === '1'
													? optsMchineType_sales
													: quotation_bTypeId === '2'
														? optsMchineType_svc
														: []
											}
											filterOptions={this.filterOptions} />
									</Row>
									<Row>
										<DropDownMenu
											sm={12}
											required={true}
											multi={true}
											label={'廠牌'}
											disabled={!enableEdit}
											stateName='quotation_brandId'
											value={quotation_brandId}
											// valueKey='flowstatus_id'
											// labelKey='flowstatus_name'
											onChange={this.handlers.onChange}
											// onChange={(option) => this.setState({ quotation_brandId: option.value })}
											options={optsBrand}
											filterOptions={this.filterOptions} />
									</Row>
								</Well>
							</Col>
							<Col sm={12}>
								<div style={{ marginBottom: 5, fontWeight: 'Bold' }}>{'金額明細'}</div>
							</Col>
							<Col sm={12}>
								<Well style={{ marginBottom: 15 }}>
									<Row>
										<Col sm={quotation_bTypeId === '1' && quotation_bMachineType === '1' ? 3 : 4}>
											<FormGroup controlId='quotation_subcost'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'最低售價加總'}</ControlLabel>
												<FormControl
													disabled={true}
													type='text'
													// onChange={this.handlers.textInputOnChange}
													value={numberHandler(quotation_subcost || 0, true)}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
										<Col sm={quotation_bTypeId === '1' && quotation_bMachineType === '1' ? 3 : 4}>
											<FormGroup controlId='quotation_totalAmount'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'總價'}</ControlLabel>
												<FormControl
													disabled={true}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={numberHandler(quotation_totalAmount, true)}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
										<Col sm={quotation_bTypeId === '1' && quotation_bMachineType === '1' ? 3 : 4}>
											<FormGroup controlId='quotation_dealAmount'>
												<ControlLabel style={{ fontWeight: 'bold' }}><RequiredMark />{'預計成交價'}</ControlLabel>
												<FormControl
													disabled={!enableEdit}
													type='text'
													onChange={this.handlers.textInputOnChange}
													value={
														!enableEdit
															? numberHandler(quotation_dealAmount, true)
															: quotation_dealAmount
													}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
										{
											quotation_bTypeId === '1' && quotation_bMachineType === '1' ?
												<DropDownMenu
													sm={3}
													required={false}
													label={'付款方式'}
													disabled={!enableEdit}
													stateName='quotation_paymentId'
													value={quotation_paymentId}
													// valueKey='flowstatus_id'
													// labelKey='flowstatus_name'
													onChange={this.handlers.onChange}
													// onChange={(option) => this.setState({ quotation_brandId: option.value })}
													options={optsPaymentRemark}
													filterOptions={this.filterOptions} />
												: ''
										}
										<Col sm={12}>
											<FormGroup controlId='quotation_paymentRemark'>
												<ControlLabel style={{ fontWeight: 'bold' }}>{'備註'}</ControlLabel>
												<FormControl
													disabled={!enableEdit}
													value={quotation_paymentRemark}
													onChange={(event) => this.setState({ quotation_paymentRemark: event.target.value })}
													componentClass='textarea'
													style={{ height: 125 }} />
											</FormGroup>
										</Col>
									</Row>
								</Well>
							</Col>
							<Col sm={12}>
								<Row>
									<Col sm={12}>
										<ControlLabel>{'產品明細'}</ControlLabel>
										{
											// 開關產品查詢
											enableEdit ?
												<Button
													onClick={(e) => { this.togglePartsSearchArea('showPartsSearchArea') }}
													style={{
														marginLeft: 5,
														marginBottom: 2,
														padding: '1px 5px',
														display: 'inline-block'
													}}>
													{
														this.state.showPartsSearchArea
															? languageData['441'][languageCode]
															: languageData['71'][languageCode]
													}
												</Button>
												: null
										}
										{/* {
											enableEdit ?
												<div
													className='btn_part add'
													style={{
														right: 15,
														position: 'absolute',
														top: -10
													}}
													onClick={() => this.addPart()}>
													<Tooltip tipText={languageData['461'][languageCode]} />
												</div>
												: null
										} */}
									</Col>
								</Row>
								{
									this.state.showPartsSearchArea ?
										<div>
											<PartsSearchAreaCt
												onAddToParts={(e) => { this.onAddToParts(e) }}
												onAddToPartsType={'partsList'}
											/>
											<Hr />
										</div>
										: null
								}
								<Well className='horizontal-scroll-wrapper' style={{ marginBottom: 15, padding: newParts.length ? '19px 10px 0' : 19 }}>
									{
										newParts.length ?
											newParts.map((item, ind) => {
												return (
													<div key={ind} className='clearfix' style={{ minWidth: quotation_bTypeId === '1' ? 1713 : 1679 }}>
														<div style={{ width: '11%', float: 'left', padding: '0 10px 0 0' }}>
															<FormGroup controlId={`partId_${ind}`}>
																<ControlLabel><RequiredMark />{'產品編號'}</ControlLabel>
																<FormControl
																	disabled={true}
																	type='text'
																	value={item.partId}
																	style={{ height: 36 }}
																	onChange={(event) => {
																		newParts[ind].partId = event.target.value;
																		this.setState({ parts: newParts });
																	}}
																/>
															</FormGroup>
														</div>
														<div style={{ width: '11%', float: 'left', padding: '0 10px 0 0' }}>
															<FormGroup controlId={`partSpec_${ind}`}>
																<ControlLabel>{'品名規格'}</ControlLabel>
																<FormControl
																	disabled={!enableEdit}
																	type='text'
																	value={item.partSpec}
																	style={{ height: 36 }}
																	onChange={(event) => {
																		newParts[ind].partSpec = event.target.value;
																		this.setState({ parts: newParts });
																	}}
																/>
															</FormGroup>
														</div>
														<div style={{ width: '11%', float: 'left', padding: '0 10px 0 0' }}>
															<FormGroup controlId={`partSpecEname_${ind}`}>
																<ControlLabel>{'英文品名'}</ControlLabel>
																<FormControl
																	disabled={!enableEdit}
																	type='text'
																	value={item.partSpecEname}
																	style={{ height: 36 }}
																	onChange={(event) => {
																		newParts[ind].partSpecEname = event.target.value;
																		this.setState({ parts: newParts });
																	}}
																/>
															</FormGroup>
														</div>
														<div style={{ width: quotation_bTypeId === '1' ? '13%' : '18%', float: 'left', padding: '0 10px 0 0' }}>
															<FormGroup controlId={`details_${ind}`}>
																<ControlLabel>{'細項描述'}</ControlLabel>
																<FormControl
																	disabled={!enableEdit}
																	value={item.details}
																	onChange={(event) => {
																		newParts[ind].details = event.target.value;
																		this.setState({ parts: newParts });
																	}}
																	componentClass='textarea'
																	style={{ height: 36 }} />
																{/* <FormControl
																	disabled={!enableEdit}
																	type='text'
																	value={item.details}
																	style={{ height: 36 }}
																	onChange={(event) => {
																		newParts[ind].details = event.target.value;
																		this.setState({ parts: newParts });
																	}}
																/> */}
															</FormGroup>
														</div>
														<div style={{ width: '4%', float: 'left', padding: '0 10px 0 0' }}>
															<FormGroup controlId={`quantity_${ind}`}>
																<ControlLabel><RequiredMark />{'數量'}</ControlLabel>
																<FormControl
																	disabled={!enableEdit}
																	type='text'
																	value={
																		!enableEdit
																			? numberHandler(item.quantity)
																			: item.quantity === 0
																				? ''
																				: item.quantity
																	}
																	style={{ height: 36 }}
																	onChange={(event) => {
																		const num = event.target.value * 1 || 0;

																		newParts[ind].quantity = num;
																		if (num * 1 > 0) {
																			const averageUnitPrice_ = Math.round(((item.unitPrice * 1) * num + (item.extraCost * 1)) / num);
																			// averageUnitPrice = (報價單價[item.unitPrice]*數量[item.quantity]+附加費用[item.extraCost])/數量[item.quantity]
																			newParts[ind].averageUnitPrice = averageUnitPrice_;
																			// subtotal = ((報價單價[item.unitPrice]*數量[item.quantity]+附加費用[item.extraCost])/數量[item.quantity])*數量[item.quantity]
																			newParts[ind].subtotal = averageUnitPrice_ * num;
																		} else {
																			newParts[ind].averageUnitPrice = 0;
																			newParts[ind].subtotal = 0;
																		}
																		this.setState({ parts: newParts }, () => {
																			this.handlers.onCalProductListSubtotal();
																		});
																	}}
																/>
															</FormGroup>
														</div>
														<div style={{ width: '5%', float: 'left', padding: '0 10px 0 0' }}>
															<FormGroup controlId={`bUnitId_${ind}`}>
																<ControlLabel style={{ fontWeight: 'bold' }}>{'單位'}</ControlLabel>
																<Select
																	openOnFocus={true}
																	disabled={!enableEdit}
																	value={item.bUnitId}
																	// valueKey={props.valueKey}
																	// labelKey={props.labelKey}
																	matchProp='label'
																	clearable={false}
																	placeholder={
																		!enableEdit
																			? 'Search here'
																			: ''
																	}
																	noResultsText='No results found'
																	onChange={(option) => {
																		newParts[ind].bUnitId = option.value;
																		this.setState({ parts: newParts });
																	}}
																	options={optsUnit}
																	filterOptions={this.filterOptions} />
															</FormGroup>
														</div>
														{
															quotation_bTypeId === '1' ?
																<div style={{ width: '5%', float: 'left', padding: '0 10px 0 0' }}>
																	<FormGroup controlId={`warrantyPeriod_${ind}`}>
																		<ControlLabel style={{ fontWeight: 'bold' }}>{'延長保固'}</ControlLabel>
																		<Select
																			openOnFocus={true}
																			disabled={!enableEdit}
																			value={item.warrantyPeriod}
																			// valueKey={props.valueKey}
																			// labelKey={props.labelKey}
																			matchProp='label'
																			clearable={false}
																			placeholder={
																				!enableEdit
																					? 'Search here'
																					: ''
																			}
																			noResultsText='No results found'
																			onChange={(option) => {
																				const val = option.value * 1 || 0,
																					calVal = Math.pow(0.95, val) || 0;

																				newParts[ind].warrantyPeriod = val;
																				newParts[ind].cost = calVal > 0 ? Math.round((item.cost_orig * 1) / calVal) : 0;
																				newParts[ind].price = calVal > 0 ? Math.round((item.price_orig * 1) / calVal) : 0;
																				this.setState({ parts: newParts });
																			}}
																			options={optsWarrantyPeriod}
																			filterOptions={this.filterOptions} />
																	</FormGroup>
																</div>
																: ''
														}
														<div style={{ width: '8%', float: 'left', padding: '0 10px 0 0' }}>
															<FormGroup controlId={`cost_${ind}`}>
																<ControlLabel style={{ fontWeight: 'bold' }}>{'最低售價'}</ControlLabel>
																<FormControl
																	disabled={true}
																	type='text'
																	value={numberHandler(item.cost, true)}
																	style={{ height: 36 }}
																// onChange={(event) => {
																// 	newParts[ind].cost = event.target.value;
																// 	this.setState({ parts: newParts });
																// }}
																/>
															</FormGroup>
														</div>
														<div style={{ width: '8%', float: 'left', padding: '0 10px 0 0' }}>
															<FormGroup controlId={`price_${ind}`}>
																<ControlLabel style={{ fontWeight: 'bold' }}>{'定價'}</ControlLabel>
																<FormControl
																	disabled={true}
																	type='text'
																	value={numberHandler(item.price, true)}
																	style={{ height: 36 }}
																// onChange={(event) => {
																// 	newParts[ind].price = event.target.value;
																// 	this.setState({ parts: newParts });
																// }}
																/>
															</FormGroup>
														</div>
														<div style={{ width: '6%', float: 'left', padding: '0 10px 0 0' }}>
															<FormGroup controlId={`unitPrice_${ind}`}>
																<ControlLabel><RequiredMark />{'報價單價'}</ControlLabel>
																<FormControl
																	disabled={!enableEdit}
																	type='text'
																	value={
																		!enableEdit
																			? numberHandler(item.unitPrice)
																			: item.unitPrice === 0
																				? ''
																				: item.unitPrice
																	}
																	style={{ height: 36 }}
																	onChange={(event) => {
																		const num = event.target.value * 1 || 0;

																		newParts[ind].unitPrice = num;
																		if (item.quantity * 1 > 0) {
																			const averageUnitPrice_ = Math.round((num * (item.quantity * 1) + (item.extraCost * 1)) / (item.quantity * 1));
																			// averageUnitPrice = (報價單價[item.unitPrice]*數量[item.quantity]+附加費用[item.extraCost])/數量[item.quantity]
																			newParts[ind].averageUnitPrice = averageUnitPrice_;
																			// subtotal = ((報價單價*數量+附加費用)/數量)*數量
																			newParts[ind].subtotal = averageUnitPrice_ * (item.quantity * 1);
																		} else {
																			newParts[ind].averageUnitPrice = 0;
																			newParts[ind].subtotal = 0;
																		}
																		this.setState({ parts: newParts }, () => {
																			this.handlers.onCalProductListSubtotal();
																		});
																	}}
																/>
															</FormGroup>
														</div>
														<div style={{ width: '6%', float: 'left', padding: '0 10px 0 0' }}>
															<FormGroup controlId={`extraCost_${ind}`}>
																<ControlLabel style={{ fontWeight: 'bold' }}>{'附加費用'}</ControlLabel>
																<FormControl
																	disabled={!enableEdit}
																	type='text'
																	value={
																		!enableEdit
																			? numberHandler(item.extraCost)
																			: item.extraCost === 0
																				? ''
																				: item.extraCost
																	}
																	style={{ height: 36 }}
																	onChange={(event) => {
																		const num = event.target.value * 1 || 0;

																		newParts[ind].extraCost = num;
																		if (item.quantity * 1 > 0) {
																			const averageUnitPrice_ = Math.round(((item.unitPrice * 1) * (item.quantity * 1) + num) / (item.quantity * 1));
																			// averageUnitPrice = (報價單價[item.unitPrice]*數量[item.quantity]+附加費用[item.extraCost])/數量[item.quantity]
																			newParts[ind].averageUnitPrice = averageUnitPrice_;
																			// subtotal = ((報價單價*數量+附加費用)/數量)*數量
																			newParts[ind].subtotal = averageUnitPrice_ * (item.quantity * 1);
																		} else {
																			newParts[ind].averageUnitPrice = 0;
																			newParts[ind].subtotal = 0;
																		}
																		this.setState({ parts: newParts }, () => {
																			this.handlers.onCalProductListSubtotal();
																		});
																	}}
																/>
															</FormGroup>
														</div>
														<div style={{ width: '6%', float: 'left', padding: '0 10px 0 0' }}>
															<FormGroup controlId={`averageUnitPrice_${ind}`}>
																<ControlLabel style={{ fontWeight: 'bold' }}>{'單價'}</ControlLabel>
																<FormControl
																	disabled={true}
																	type='text'
																	value={numberHandler(item.averageUnitPrice)}
																	style={{ height: 36 }}
																// onChange={(event) => {
																// 	newParts[ind].averageUnitPrice = (item.price * item.quantity + item.extraCost) / item.quantity;
																// 	this.setState({ parts: newParts });
																// }}
																/>
															</FormGroup>
														</div>
														<div style={{ width: '6%', float: 'left', padding: 0, position: 'relative' }}>
															<FormGroup controlId={`subtotal_${ind}`}>
																<ControlLabel style={{ fontWeight: 'bold' }}>{'小計'}</ControlLabel>
																<FormControl
																	disabled={true}
																	type='text'
																	value={numberHandler(item.subtotal)}
																	style={{ height: 36 }}
																// onChange={(event) => {
																// 	newParts[ind].subtotal = event.target.value;
																// 	this.setState({ parts: newParts });
																// }}
																/>
															</FormGroup>
															{
																enableEdit ?
																	<div
																		className='btn_part remove'
																		style={{ right: 0 }}
																		onClick={() => this.removePart(ind)}>
																		<Tooltip tipText={languageData['609'][languageCode]} />
																	</div>
																	: null
															}
														</div>
													</div>
												)
											})
											:
											<div>{'查無資料'}</div>
									}
								</Well>
							</Col>
							<Col sm={12}>
								<FormGroup controlId='quotation_productRemark'>
									<ControlLabel style={{ fontWeight: 'bold' }}>{'特殊說明'}</ControlLabel>
									<FormControl
										disabled={!enableEdit}
										value={quotation_productRemark}
										onChange={(event) => this.setState({ quotation_productRemark: event.target.value })}
										componentClass='textarea'
										style={{ height: 100 }} />
								</FormGroup>
							</Col>
						</Row>
					</Modal.Body>
					<Modal.Footer>
						<div></div>
						<div style={{ justifyContent: 'center' }}>
							{btn_prev_page}
							{btn_next_page}
						</div>
						<div style={{ justifyContent: 'flex-end' }}>
							{btn_save}
							{/* {btnExportPDF}
							{btn_copy} */}
							<Button onClick={closeModal}>{btn_cancel_text}</Button>
						</div>
					</Modal.Footer>
				</Modal>
				{
					showSearchSNResult ?
						<SearchSNResult
							selectSNValue={selectSNValue}
							filterOptions={this.filterOptions}
							serialNumberList={serialNumberList}
							dispatch={this.props.dispatch}
							onSNModalChange={(item) => { this.handlers.onSNModalChange(item) }}
							closeModal={() => { this.handlers.onSearchSNResultClick(0) }}
							onSaveSN={() => { this.handlers.onSearchSNResultClick(1) }}
							propsPackageFromSkyFamily={this.props.propsPackageFromSkyFamily}
							parentStateHandler={this.props.parentStateHandler} />
						: ''
				}
				{
					// 利用&&運算子，前參數true時會傳回後參數，false時會傳回自己
					// div包裝是消除scroll出現導致畫面跳動，position設為relative讓pdf內容的絕對定位歸屬於其下，讓overflow hidden有效
					repairPdfContent && <div style={{ position: 'relative', overflow: 'hidden' }}>{repairPdfContent.map((item, ind) => item)}</div>
				}
				{
					showSearchCompanyContactModal ?
						<SearchCompanyContactResult
							filterOptions={this.filterOptions}
							dispatch={this.props.dispatch}
							state={this.state}
							setSearchData={(stateName, data) => { this.setState({ [stateName]: data }) }}
							onTabClickSearch={(type) => { this.onTabClickSearch(type) }}
							closeModal={(e) => { this.handlers.onShowSearchCompanyContactModal(0) }}
							onChangeSelectValue={(type, data) => { this.handlers.onSearchCompanyData(type, data) }}
							onSearch={(type, data) => { this.handlers.onSearchCompanyData(type, data) }}
							onSave={(type) => { this.handlers.onSearchCompanyData(type) }}
							propsPackageFromSkyFamily={this.props.propsPackageFromSkyFamily}
							parentStateHandler={this.props.parentStateHandler} />
						: null
				}
			</div >
		);
	}
}





// WEBPACK FOOTER //
// ./src/salesky/routes/formList/formQuotationModalCt.jsx